var cov_1hqp0yq0kg = function () {
  var path = '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/program/programCtrl.js',
      hash = '1911e9a127b8951056c4d357e19e83cb1256b203',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/program/programCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 6,
          column: 15
        },
        end: {
          line: 6,
          column: 26
        }
      },
      '1': {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 10,
          column: 4
        }
      },
      '2': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 35
        }
      },
      '3': {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 24
        }
      },
      '4': {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 13,
          column: 4
        }
      },
      '5': {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 40
        }
      },
      '6': {
        start: {
          line: 15,
          column: 0
        },
        end: {
          line: 721,
          column: 3
        }
      },
      '7': {
        start: {
          line: 16,
          column: 15
        },
        end: {
          line: 16,
          column: 26
        }
      },
      '8': {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 17,
          column: 52
        }
      },
      '9': {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 21,
          column: 5
        }
      },
      '10': {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 49
        }
      },
      '11': {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 37
        }
      },
      '12': {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 23,
          column: 35
        }
      },
      '13': {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 26,
          column: 4
        }
      },
      '14': {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 48
        }
      },
      '15': {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 31,
          column: 4
        }
      },
      '16': {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 114
        }
      },
      '17': {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 33,
          column: 28
        }
      },
      '18': {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 34,
          column: 27
        }
      },
      '19': {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 35,
          column: 25
        }
      },
      '20': {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 39,
          column: 5
        }
      },
      '21': {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 33
        }
      },
      '22': {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 43,
          column: 4
        }
      },
      '23': {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 51,
          column: 4
        }
      },
      '24': {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 174
        }
      },
      '25': {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 50,
          column: 5
        }
      },
      '26': {
        start: {
          line: 47,
          column: 16
        },
        end: {
          line: 47,
          column: 75
        }
      },
      '27': {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 21
        }
      },
      '28': {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 87
        }
      },
      '29': {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 70,
          column: 4
        }
      },
      '30': {
        start: {
          line: 72,
          column: 2
        },
        end: {
          line: 80,
          column: 5
        }
      },
      '31': {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 75,
          column: 5
        }
      },
      '32': {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 15
        }
      },
      '33': {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 78,
          column: 5
        }
      },
      '34': {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 77,
          column: 16
        }
      },
      '35': {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 13
        }
      },
      '36': {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 91,
          column: 4
        }
      },
      '37': {
        start: {
          line: 92,
          column: 2
        },
        end: {
          line: 94,
          column: 4
        }
      },
      '38': {
        start: {
          line: 95,
          column: 2
        },
        end: {
          line: 95,
          column: 27
        }
      },
      '39': {
        start: {
          line: 96,
          column: 2
        },
        end: {
          line: 96,
          column: 31
        }
      },
      '40': {
        start: {
          line: 97,
          column: 2
        },
        end: {
          line: 97,
          column: 53
        }
      },
      '41': {
        start: {
          line: 99,
          column: 2
        },
        end: {
          line: 211,
          column: 4
        }
      },
      '42': {
        start: {
          line: 100,
          column: 17
        },
        end: {
          line: 100,
          column: 31
        }
      },
      '43': {
        start: {
          line: 102,
          column: 24
        },
        end: {
          line: 102,
          column: 64
        }
      },
      '44': {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 28
        }
      },
      '45': {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 210,
          column: 7
        }
      },
      '46': {
        start: {
          line: 105,
          column: 17
        },
        end: {
          line: 105,
          column: 52
        }
      },
      '47': {
        start: {
          line: 106,
          column: 19
        },
        end: {
          line: 106,
          column: 33
        }
      },
      '48': {
        start: {
          line: 107,
          column: 6
        },
        end: {
          line: 107,
          column: 43
        }
      },
      '49': {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 208,
          column: 7
        }
      },
      '50': {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 166,
          column: 10
        }
      },
      '51': {
        start: {
          line: 168,
          column: 8
        },
        end: {
          line: 168,
          column: 76
        }
      },
      '52': {
        start: {
          line: 169,
          column: 8
        },
        end: {
          line: 169,
          column: 66
        }
      },
      '53': {
        start: {
          line: 170,
          column: 8
        },
        end: {
          line: 170,
          column: 36
        }
      },
      '54': {
        start: {
          line: 171,
          column: 8
        },
        end: {
          line: 171,
          column: 63
        }
      },
      '55': {
        start: {
          line: 172,
          column: 8
        },
        end: {
          line: 172,
          column: 83
        }
      },
      '56': {
        start: {
          line: 173,
          column: 8
        },
        end: {
          line: 173,
          column: 51
        }
      },
      '57': {
        start: {
          line: 174,
          column: 8
        },
        end: {
          line: 174,
          column: 43
        }
      },
      '58': {
        start: {
          line: 175,
          column: 8
        },
        end: {
          line: 175,
          column: 35
        }
      },
      '59': {
        start: {
          line: 176,
          column: 8
        },
        end: {
          line: 176,
          column: 41
        }
      },
      '60': {
        start: {
          line: 177,
          column: 8
        },
        end: {
          line: 177,
          column: 47
        }
      },
      '61': {
        start: {
          line: 179,
          column: 8
        },
        end: {
          line: 179,
          column: 70
        }
      },
      '62': {
        start: {
          line: 180,
          column: 8
        },
        end: {
          line: 180,
          column: 66
        }
      },
      '63': {
        start: {
          line: 181,
          column: 8
        },
        end: {
          line: 181,
          column: 71
        }
      },
      '64': {
        start: {
          line: 183,
          column: 22
        },
        end: {
          line: 183,
          column: 65
        }
      },
      '65': {
        start: {
          line: 184,
          column: 8
        },
        end: {
          line: 184,
          column: 26
        }
      },
      '66': {
        start: {
          line: 185,
          column: 8
        },
        end: {
          line: 187,
          column: 9
        }
      },
      '67': {
        start: {
          line: 186,
          column: 10
        },
        end: {
          line: 186,
          column: 84
        }
      },
      '68': {
        start: {
          line: 188,
          column: 8
        },
        end: {
          line: 190,
          column: 9
        }
      },
      '69': {
        start: {
          line: 189,
          column: 10
        },
        end: {
          line: 189,
          column: 28
        }
      },
      '70': {
        start: {
          line: 191,
          column: 8
        },
        end: {
          line: 191,
          column: 58
        }
      },
      '71': {
        start: {
          line: 192,
          column: 8
        },
        end: {
          line: 192,
          column: 88
        }
      },
      '72': {
        start: {
          line: 194,
          column: 8
        },
        end: {
          line: 207,
          column: 10
        }
      },
      '73': {
        start: {
          line: 209,
          column: 6
        },
        end: {
          line: 209,
          column: 24
        }
      },
      '74': {
        start: {
          line: 213,
          column: 2
        },
        end: {
          line: 213,
          column: 27
        }
      },
      '75': {
        start: {
          line: 214,
          column: 2
        },
        end: {
          line: 216,
          column: 4
        }
      },
      '76': {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 215,
          column: 30
        }
      },
      '77': {
        start: {
          line: 217,
          column: 2
        },
        end: {
          line: 319,
          column: 4
        }
      },
      '78': {
        start: {
          line: 218,
          column: 25
        },
        end: {
          line: 218,
          column: 58
        }
      },
      '79': {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 219,
          column: 104
        }
      },
      '80': {
        start: {
          line: 220,
          column: 4
        },
        end: {
          line: 220,
          column: 104
        }
      },
      '81': {
        start: {
          line: 221,
          column: 4
        },
        end: {
          line: 221,
          column: 96
        }
      },
      '82': {
        start: {
          line: 222,
          column: 4
        },
        end: {
          line: 222,
          column: 66
        }
      },
      '83': {
        start: {
          line: 223,
          column: 4
        },
        end: {
          line: 223,
          column: 31
        }
      },
      '84': {
        start: {
          line: 224,
          column: 4
        },
        end: {
          line: 224,
          column: 84
        }
      },
      '85': {
        start: {
          line: 224,
          column: 74
        },
        end: {
          line: 224,
          column: 82
        }
      },
      '86': {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 225,
          column: 113
        }
      },
      '87': {
        start: {
          line: 226,
          column: 4
        },
        end: {
          line: 226,
          column: 56
        }
      },
      '88': {
        start: {
          line: 227,
          column: 4
        },
        end: {
          line: 227,
          column: 71
        }
      },
      '89': {
        start: {
          line: 228,
          column: 4
        },
        end: {
          line: 228,
          column: 79
        }
      },
      '90': {
        start: {
          line: 229,
          column: 4
        },
        end: {
          line: 229,
          column: 126
        }
      },
      '91': {
        start: {
          line: 230,
          column: 4
        },
        end: {
          line: 230,
          column: 73
        }
      },
      '92': {
        start: {
          line: 232,
          column: 4
        },
        end: {
          line: 232,
          column: 85
        }
      },
      '93': {
        start: {
          line: 233,
          column: 4
        },
        end: {
          line: 233,
          column: 105
        }
      },
      '94': {
        start: {
          line: 234,
          column: 4
        },
        end: {
          line: 234,
          column: 73
        }
      },
      '95': {
        start: {
          line: 235,
          column: 4
        },
        end: {
          line: 235,
          column: 65
        }
      },
      '96': {
        start: {
          line: 236,
          column: 4
        },
        end: {
          line: 236,
          column: 57
        }
      },
      '97': {
        start: {
          line: 237,
          column: 4
        },
        end: {
          line: 237,
          column: 63
        }
      },
      '98': {
        start: {
          line: 238,
          column: 4
        },
        end: {
          line: 238,
          column: 69
        }
      },
      '99': {
        start: {
          line: 239,
          column: 4
        },
        end: {
          line: 239,
          column: 69
        }
      },
      '100': {
        start: {
          line: 241,
          column: 4
        },
        end: {
          line: 241,
          column: 63
        }
      },
      '101': {
        start: {
          line: 242,
          column: 4
        },
        end: {
          line: 242,
          column: 37
        }
      },
      '102': {
        start: {
          line: 243,
          column: 4
        },
        end: {
          line: 243,
          column: 31
        }
      },
      '103': {
        start: {
          line: 244,
          column: 4
        },
        end: {
          line: 244,
          column: 68
        }
      },
      '104': {
        start: {
          line: 245,
          column: 4
        },
        end: {
          line: 245,
          column: 78
        }
      },
      '105': {
        start: {
          line: 248,
          column: 4
        },
        end: {
          line: 258,
          column: 6
        }
      },
      '106': {
        start: {
          line: 259,
          column: 4
        },
        end: {
          line: 262,
          column: 6
        }
      },
      '107': {
        start: {
          line: 264,
          column: 4
        },
        end: {
          line: 277,
          column: 5
        }
      },
      '108': {
        start: {
          line: 265,
          column: 19
        },
        end: {
          line: 265,
          column: 41
        }
      },
      '109': {
        start: {
          line: 266,
          column: 6
        },
        end: {
          line: 276,
          column: 7
        }
      },
      '110': {
        start: {
          line: 268,
          column: 8
        },
        end: {
          line: 275,
          column: 9
        }
      },
      '111': {
        start: {
          line: 269,
          column: 10
        },
        end: {
          line: 272,
          column: 12
        }
      },
      '112': {
        start: {
          line: 273,
          column: 10
        },
        end: {
          line: 273,
          column: 30
        }
      },
      '113': {
        start: {
          line: 274,
          column: 10
        },
        end: {
          line: 274,
          column: 17
        }
      },
      '114': {
        start: {
          line: 278,
          column: 4
        },
        end: {
          line: 285,
          column: 5
        }
      },
      '115': {
        start: {
          line: 279,
          column: 6
        },
        end: {
          line: 282,
          column: 8
        }
      },
      '116': {
        start: {
          line: 283,
          column: 6
        },
        end: {
          line: 283,
          column: 26
        }
      },
      '117': {
        start: {
          line: 284,
          column: 6
        },
        end: {
          line: 284,
          column: 13
        }
      },
      '118': {
        start: {
          line: 286,
          column: 4
        },
        end: {
          line: 293,
          column: 5
        }
      },
      '119': {
        start: {
          line: 287,
          column: 6
        },
        end: {
          line: 290,
          column: 8
        }
      },
      '120': {
        start: {
          line: 291,
          column: 6
        },
        end: {
          line: 291,
          column: 26
        }
      },
      '121': {
        start: {
          line: 292,
          column: 6
        },
        end: {
          line: 292,
          column: 13
        }
      },
      '122': {
        start: {
          line: 295,
          column: 4
        },
        end: {
          line: 295,
          column: 33
        }
      },
      '123': {
        start: {
          line: 296,
          column: 4
        },
        end: {
          line: 296,
          column: 38
        }
      },
      '124': {
        start: {
          line: 298,
          column: 4
        },
        end: {
          line: 317,
          column: 5
        }
      },
      '125': {
        start: {
          line: 299,
          column: 6
        },
        end: {
          line: 314,
          column: 9
        }
      },
      '126': {
        start: {
          line: 310,
          column: 8
        },
        end: {
          line: 312,
          column: 9
        }
      },
      '127': {
        start: {
          line: 311,
          column: 10
        },
        end: {
          line: 311,
          column: 17
        }
      },
      '128': {
        start: {
          line: 313,
          column: 8
        },
        end: {
          line: 313,
          column: 43
        }
      },
      '129': {
        start: {
          line: 316,
          column: 6
        },
        end: {
          line: 316,
          column: 41
        }
      },
      '130': {
        start: {
          line: 318,
          column: 4
        },
        end: {
          line: 318,
          column: 32
        }
      },
      '131': {
        start: {
          line: 321,
          column: 2
        },
        end: {
          line: 338,
          column: 5
        }
      },
      '132': {
        start: {
          line: 322,
          column: 4
        },
        end: {
          line: 337,
          column: 5
        }
      },
      '133': {
        start: {
          line: 323,
          column: 6
        },
        end: {
          line: 336,
          column: 9
        }
      },
      '134': {
        start: {
          line: 333,
          column: 8
        },
        end: {
          line: 335,
          column: 9
        }
      },
      '135': {
        start: {
          line: 334,
          column: 10
        },
        end: {
          line: 334,
          column: 17
        }
      },
      '136': {
        start: {
          line: 340,
          column: 2
        },
        end: {
          line: 351,
          column: 5
        }
      },
      '137': {
        start: {
          line: 341,
          column: 4
        },
        end: {
          line: 350,
          column: 6
        }
      },
      '138': {
        start: {
          line: 348,
          column: 8
        },
        end: {
          line: 348,
          column: 20
        }
      },
      '139': {
        start: {
          line: 352,
          column: 2
        },
        end: {
          line: 391,
          column: 4
        }
      },
      '140': {
        start: {
          line: 353,
          column: 19
        },
        end: {
          line: 353,
          column: 51
        }
      },
      '141': {
        start: {
          line: 354,
          column: 4
        },
        end: {
          line: 354,
          column: 28
        }
      },
      '142': {
        start: {
          line: 355,
          column: 4
        },
        end: {
          line: 390,
          column: 7
        }
      },
      '143': {
        start: {
          line: 356,
          column: 19
        },
        end: {
          line: 356,
          column: 39
        }
      },
      '144': {
        start: {
          line: 357,
          column: 6
        },
        end: {
          line: 380,
          column: 7
        }
      },
      '145': {
        start: {
          line: 358,
          column: 8
        },
        end: {
          line: 360,
          column: 9
        }
      },
      '146': {
        start: {
          line: 359,
          column: 10
        },
        end: {
          line: 359,
          column: 115
        }
      },
      '147': {
        start: {
          line: 361,
          column: 8
        },
        end: {
          line: 363,
          column: 9
        }
      },
      '148': {
        start: {
          line: 362,
          column: 10
        },
        end: {
          line: 362,
          column: 57
        }
      },
      '149': {
        start: {
          line: 364,
          column: 8
        },
        end: {
          line: 368,
          column: 9
        }
      },
      '150': {
        start: {
          line: 365,
          column: 10
        },
        end: {
          line: 365,
          column: 37
        }
      },
      '151': {
        start: {
          line: 366,
          column: 10
        },
        end: {
          line: 366,
          column: 56
        }
      },
      '152': {
        start: {
          line: 367,
          column: 10
        },
        end: {
          line: 367,
          column: 93
        }
      },
      '153': {
        start: {
          line: 369,
          column: 8
        },
        end: {
          line: 379,
          column: 9
        }
      },
      '154': {
        start: {
          line: 370,
          column: 10
        },
        end: {
          line: 378,
          column: 13
        }
      },
      '155': {
        start: {
          line: 375,
          column: 12
        },
        end: {
          line: 377,
          column: 13
        }
      },
      '156': {
        start: {
          line: 376,
          column: 14
        },
        end: {
          line: 376,
          column: 21
        }
      },
      '157': {
        start: {
          line: 383,
          column: 6
        },
        end: {
          line: 387,
          column: 7
        }
      },
      '158': {
        start: {
          line: 384,
          column: 8
        },
        end: {
          line: 386,
          column: 11
        }
      },
      '159': {
        start: {
          line: 389,
          column: 6
        },
        end: {
          line: 389,
          column: 34
        }
      },
      '160': {
        start: {
          line: 393,
          column: 2
        },
        end: {
          line: 480,
          column: 4
        }
      },
      '161': {
        start: {
          line: 394,
          column: 4
        },
        end: {
          line: 394,
          column: 29
        }
      },
      '162': {
        start: {
          line: 395,
          column: 4
        },
        end: {
          line: 395,
          column: 47
        }
      },
      '163': {
        start: {
          line: 396,
          column: 4
        },
        end: {
          line: 396,
          column: 29
        }
      },
      '164': {
        start: {
          line: 397,
          column: 4
        },
        end: {
          line: 397,
          column: 24
        }
      },
      '165': {
        start: {
          line: 398,
          column: 4
        },
        end: {
          line: 398,
          column: 30
        }
      },
      '166': {
        start: {
          line: 399,
          column: 4
        },
        end: {
          line: 399,
          column: 30
        }
      },
      '167': {
        start: {
          line: 400,
          column: 4
        },
        end: {
          line: 400,
          column: 24
        }
      },
      '168': {
        start: {
          line: 401,
          column: 4
        },
        end: {
          line: 401,
          column: 45
        }
      },
      '169': {
        start: {
          line: 402,
          column: 4
        },
        end: {
          line: 402,
          column: 128
        }
      },
      '170': {
        start: {
          line: 403,
          column: 4
        },
        end: {
          line: 403,
          column: 118
        }
      },
      '171': {
        start: {
          line: 405,
          column: 4
        },
        end: {
          line: 413,
          column: 5
        }
      },
      '172': {
        start: {
          line: 406,
          column: 6
        },
        end: {
          line: 408,
          column: 9
        }
      },
      '173': {
        start: {
          line: 407,
          column: 8
        },
        end: {
          line: 407,
          column: 45
        }
      },
      '174': {
        start: {
          line: 410,
          column: 6
        },
        end: {
          line: 412,
          column: 7
        }
      },
      '175': {
        start: {
          line: 411,
          column: 8
        },
        end: {
          line: 411,
          column: 109
        }
      },
      '176': {
        start: {
          line: 415,
          column: 4
        },
        end: {
          line: 415,
          column: 60
        }
      },
      '177': {
        start: {
          line: 416,
          column: 4
        },
        end: {
          line: 416,
          column: 64
        }
      },
      '178': {
        start: {
          line: 417,
          column: 4
        },
        end: {
          line: 417,
          column: 68
        }
      },
      '179': {
        start: {
          line: 421,
          column: 4
        },
        end: {
          line: 421,
          column: 130
        }
      },
      '180': {
        start: {
          line: 422,
          column: 4
        },
        end: {
          line: 422,
          column: 62
        }
      },
      '181': {
        start: {
          line: 423,
          column: 4
        },
        end: {
          line: 423,
          column: 70
        }
      },
      '182': {
        start: {
          line: 424,
          column: 4
        },
        end: {
          line: 424,
          column: 76
        }
      },
      '183': {
        start: {
          line: 425,
          column: 4
        },
        end: {
          line: 425,
          column: 64
        }
      },
      '184': {
        start: {
          line: 426,
          column: 4
        },
        end: {
          line: 426,
          column: 54
        }
      },
      '185': {
        start: {
          line: 427,
          column: 4
        },
        end: {
          line: 427,
          column: 106
        }
      },
      '186': {
        start: {
          line: 428,
          column: 4
        },
        end: {
          line: 438,
          column: 6
        }
      },
      '187': {
        start: {
          line: 439,
          column: 4
        },
        end: {
          line: 439,
          column: 40
        }
      },
      '188': {
        start: {
          line: 440,
          column: 4
        },
        end: {
          line: 440,
          column: 80
        }
      },
      '189': {
        start: {
          line: 441,
          column: 4
        },
        end: {
          line: 445,
          column: 5
        }
      },
      '190': {
        start: {
          line: 442,
          column: 6
        },
        end: {
          line: 444,
          column: 9
        }
      },
      '191': {
        start: {
          line: 443,
          column: 8
        },
        end: {
          line: 443,
          column: 52
        }
      },
      '192': {
        start: {
          line: 446,
          column: 4
        },
        end: {
          line: 446,
          column: 34
        }
      },
      '193': {
        start: {
          line: 447,
          column: 4
        },
        end: {
          line: 456,
          column: 7
        }
      },
      '194': {
        start: {
          line: 448,
          column: 6
        },
        end: {
          line: 453,
          column: 7
        }
      },
      '195': {
        start: {
          line: 449,
          column: 8
        },
        end: {
          line: 452,
          column: 10
        }
      },
      '196': {
        start: {
          line: 455,
          column: 6
        },
        end: {
          line: 455,
          column: 27
        }
      },
      '197': {
        start: {
          line: 457,
          column: 4
        },
        end: {
          line: 460,
          column: 6
        }
      },
      '198': {
        start: {
          line: 461,
          column: 4
        },
        end: {
          line: 463,
          column: 7
        }
      },
      '199': {
        start: {
          line: 462,
          column: 6
        },
        end: {
          line: 462,
          column: 26
        }
      },
      '200': {
        start: {
          line: 465,
          column: 4
        },
        end: {
          line: 465,
          column: 50
        }
      },
      '201': {
        start: {
          line: 466,
          column: 4
        },
        end: {
          line: 466,
          column: 33
        }
      },
      '202': {
        start: {
          line: 467,
          column: 4
        },
        end: {
          line: 479,
          column: 7
        }
      },
      '203': {
        start: {
          line: 468,
          column: 6
        },
        end: {
          line: 477,
          column: 7
        }
      },
      '204': {
        start: {
          line: 469,
          column: 8
        },
        end: {
          line: 471,
          column: 9
        }
      },
      '205': {
        start: {
          line: 470,
          column: 10
        },
        end: {
          line: 470,
          column: 58
        }
      },
      '206': {
        start: {
          line: 472,
          column: 8
        },
        end: {
          line: 474,
          column: 9
        }
      },
      '207': {
        start: {
          line: 473,
          column: 10
        },
        end: {
          line: 473,
          column: 56
        }
      },
      '208': {
        start: {
          line: 476,
          column: 8
        },
        end: {
          line: 476,
          column: 39
        }
      },
      '209': {
        start: {
          line: 478,
          column: 6
        },
        end: {
          line: 478,
          column: 34
        }
      },
      '210': {
        start: {
          line: 481,
          column: 2
        },
        end: {
          line: 527,
          column: 4
        }
      },
      '211': {
        start: {
          line: 482,
          column: 4
        },
        end: {
          line: 526,
          column: 7
        }
      },
      '212': {
        start: {
          line: 494,
          column: 6
        },
        end: {
          line: 496,
          column: 7
        }
      },
      '213': {
        start: {
          line: 495,
          column: 8
        },
        end: {
          line: 495,
          column: 15
        }
      },
      '214': {
        start: {
          line: 497,
          column: 6
        },
        end: {
          line: 497,
          column: 30
        }
      },
      '215': {
        start: {
          line: 498,
          column: 27
        },
        end: {
          line: 514,
          column: 7
        }
      },
      '216': {
        start: {
          line: 515,
          column: 6
        },
        end: {
          line: 525,
          column: 9
        }
      },
      '217': {
        start: {
          line: 516,
          column: 8
        },
        end: {
          line: 523,
          column: 9
        }
      },
      '218': {
        start: {
          line: 517,
          column: 10
        },
        end: {
          line: 520,
          column: 13
        }
      },
      '219': {
        start: {
          line: 521,
          column: 10
        },
        end: {
          line: 521,
          column: 35
        }
      },
      '220': {
        start: {
          line: 522,
          column: 10
        },
        end: {
          line: 522,
          column: 17
        }
      },
      '221': {
        start: {
          line: 524,
          column: 8
        },
        end: {
          line: 524,
          column: 38
        }
      },
      '222': {
        start: {
          line: 529,
          column: 2
        },
        end: {
          line: 548,
          column: 4
        }
      },
      '223': {
        start: {
          line: 530,
          column: 27
        },
        end: {
          line: 530,
          column: 47
        }
      },
      '224': {
        start: {
          line: 531,
          column: 4
        },
        end: {
          line: 531,
          column: 32
        }
      },
      '225': {
        start: {
          line: 532,
          column: 4
        },
        end: {
          line: 547,
          column: 7
        }
      },
      '226': {
        start: {
          line: 533,
          column: 6
        },
        end: {
          line: 543,
          column: 9
        }
      },
      '227': {
        start: {
          line: 544,
          column: 6
        },
        end: {
          line: 544,
          column: 34
        }
      },
      '228': {
        start: {
          line: 545,
          column: 6
        },
        end: {
          line: 545,
          column: 35
        }
      },
      '229': {
        start: {
          line: 546,
          column: 6
        },
        end: {
          line: 546,
          column: 49
        }
      },
      '230': {
        start: {
          line: 549,
          column: 2
        },
        end: {
          line: 558,
          column: 4
        }
      },
      '231': {
        start: {
          line: 550,
          column: 4
        },
        end: {
          line: 557,
          column: 7
        }
      },
      '232': {
        start: {
          line: 560,
          column: 2
        },
        end: {
          line: 573,
          column: 4
        }
      },
      '233': {
        start: {
          line: 561,
          column: 4
        },
        end: {
          line: 561,
          column: 50
        }
      },
      '234': {
        start: {
          line: 562,
          column: 4
        },
        end: {
          line: 562,
          column: 96
        }
      },
      '235': {
        start: {
          line: 563,
          column: 4
        },
        end: {
          line: 563,
          column: 94
        }
      },
      '236': {
        start: {
          line: 565,
          column: 4
        },
        end: {
          line: 572,
          column: 7
        }
      },
      '237': {
        start: {
          line: 574,
          column: 2
        },
        end: {
          line: 592,
          column: 4
        }
      },
      '238': {
        start: {
          line: 575,
          column: 17
        },
        end: {
          line: 582,
          column: 5
        }
      },
      '239': {
        start: {
          line: 584,
          column: 15
        },
        end: {
          line: 584,
          column: 75
        }
      },
      '240': {
        start: {
          line: 585,
          column: 18
        },
        end: {
          line: 585,
          column: 53
        }
      },
      '241': {
        start: {
          line: 586,
          column: 4
        },
        end: {
          line: 590,
          column: 5
        }
      },
      '242': {
        start: {
          line: 587,
          column: 6
        },
        end: {
          line: 587,
          column: 41
        }
      },
      '243': {
        start: {
          line: 589,
          column: 6
        },
        end: {
          line: 589,
          column: 38
        }
      },
      '244': {
        start: {
          line: 594,
          column: 2
        },
        end: {
          line: 619,
          column: 4
        }
      },
      '245': {
        start: {
          line: 595,
          column: 4
        },
        end: {
          line: 618,
          column: 7
        }
      },
      '246': {
        start: {
          line: 608,
          column: 6
        },
        end: {
          line: 610,
          column: 7
        }
      },
      '247': {
        start: {
          line: 609,
          column: 8
        },
        end: {
          line: 609,
          column: 15
        }
      },
      '248': {
        start: {
          line: 611,
          column: 20
        },
        end: {
          line: 611,
          column: 54
        }
      },
      '249': {
        start: {
          line: 612,
          column: 6
        },
        end: {
          line: 617,
          column: 7
        }
      },
      '250': {
        start: {
          line: 613,
          column: 8
        },
        end: {
          line: 615,
          column: 9
        }
      },
      '251': {
        start: {
          line: 614,
          column: 10
        },
        end: {
          line: 614,
          column: 48
        }
      },
      '252': {
        start: {
          line: 616,
          column: 8
        },
        end: {
          line: 616,
          column: 46
        }
      },
      '253': {
        start: {
          line: 621,
          column: 2
        },
        end: {
          line: 621,
          column: 67
        }
      },
      '254': {
        start: {
          line: 623,
          column: 2
        },
        end: {
          line: 623,
          column: 26
        }
      },
      '255': {
        start: {
          line: 624,
          column: 2
        },
        end: {
          line: 630,
          column: 5
        }
      },
      '256': {
        start: {
          line: 625,
          column: 4
        },
        end: {
          line: 628,
          column: 5
        }
      },
      '257': {
        start: {
          line: 626,
          column: 6
        },
        end: {
          line: 626,
          column: 40
        }
      },
      '258': {
        start: {
          line: 627,
          column: 6
        },
        end: {
          line: 627,
          column: 113
        }
      },
      '259': {
        start: {
          line: 629,
          column: 4
        },
        end: {
          line: 629,
          column: 20
        }
      },
      '260': {
        start: {
          line: 632,
          column: 2
        },
        end: {
          line: 632,
          column: 29
        }
      },
      '261': {
        start: {
          line: 634,
          column: 19
        },
        end: {
          line: 639,
          column: 4
        }
      },
      '262': {
        start: {
          line: 641,
          column: 2
        },
        end: {
          line: 645,
          column: 4
        }
      },
      '263': {
        start: {
          line: 642,
          column: 4
        },
        end: {
          line: 642,
          column: 66
        }
      },
      '264': {
        start: {
          line: 643,
          column: 4
        },
        end: {
          line: 643,
          column: 28
        }
      },
      '265': {
        start: {
          line: 644,
          column: 4
        },
        end: {
          line: 644,
          column: 22
        }
      },
      '266': {
        start: {
          line: 647,
          column: 2
        },
        end: {
          line: 650,
          column: 4
        }
      },
      '267': {
        start: {
          line: 648,
          column: 4
        },
        end: {
          line: 648,
          column: 70
        }
      },
      '268': {
        start: {
          line: 649,
          column: 4
        },
        end: {
          line: 649,
          column: 29
        }
      },
      '269': {
        start: {
          line: 652,
          column: 2
        },
        end: {
          line: 655,
          column: 5
        }
      },
      '270': {
        start: {
          line: 653,
          column: 4
        },
        end: {
          line: 653,
          column: 45
        }
      },
      '271': {
        start: {
          line: 654,
          column: 4
        },
        end: {
          line: 654,
          column: 33
        }
      },
      '272': {
        start: {
          line: 657,
          column: 2
        },
        end: {
          line: 659,
          column: 5
        }
      },
      '273': {
        start: {
          line: 658,
          column: 4
        },
        end: {
          line: 658,
          column: 33
        }
      },
      '274': {
        start: {
          line: 661,
          column: 2
        },
        end: {
          line: 677,
          column: 5
        }
      },
      '275': {
        start: {
          line: 662,
          column: 4
        },
        end: {
          line: 662,
          column: 56
        }
      },
      '276': {
        start: {
          line: 663,
          column: 4
        },
        end: {
          line: 668,
          column: 5
        }
      },
      '277': {
        start: {
          line: 664,
          column: 6
        },
        end: {
          line: 666,
          column: 9
        }
      },
      '278': {
        start: {
          line: 665,
          column: 8
        },
        end: {
          line: 665,
          column: 42
        }
      },
      '279': {
        start: {
          line: 667,
          column: 6
        },
        end: {
          line: 667,
          column: 13
        }
      },
      '280': {
        start: {
          line: 669,
          column: 4
        },
        end: {
          line: 675,
          column: 5
        }
      },
      '281': {
        start: {
          line: 670,
          column: 6
        },
        end: {
          line: 674,
          column: 7
        }
      },
      '282': {
        start: {
          line: 671,
          column: 8
        },
        end: {
          line: 671,
          column: 38
        }
      },
      '283': {
        start: {
          line: 672,
          column: 8
        },
        end: {
          line: 672,
          column: 40
        }
      },
      '284': {
        start: {
          line: 673,
          column: 8
        },
        end: {
          line: 673,
          column: 15
        }
      },
      '285': {
        start: {
          line: 676,
          column: 4
        },
        end: {
          line: 676,
          column: 37
        }
      },
      '286': {
        start: {
          line: 679,
          column: 2
        },
        end: {
          line: 695,
          column: 5
        }
      },
      '287': {
        start: {
          line: 680,
          column: 4
        },
        end: {
          line: 680,
          column: 56
        }
      },
      '288': {
        start: {
          line: 681,
          column: 4
        },
        end: {
          line: 686,
          column: 5
        }
      },
      '289': {
        start: {
          line: 682,
          column: 6
        },
        end: {
          line: 684,
          column: 9
        }
      },
      '290': {
        start: {
          line: 683,
          column: 8
        },
        end: {
          line: 683,
          column: 42
        }
      },
      '291': {
        start: {
          line: 685,
          column: 6
        },
        end: {
          line: 685,
          column: 13
        }
      },
      '292': {
        start: {
          line: 687,
          column: 4
        },
        end: {
          line: 693,
          column: 5
        }
      },
      '293': {
        start: {
          line: 688,
          column: 6
        },
        end: {
          line: 692,
          column: 7
        }
      },
      '294': {
        start: {
          line: 689,
          column: 8
        },
        end: {
          line: 689,
          column: 38
        }
      },
      '295': {
        start: {
          line: 690,
          column: 8
        },
        end: {
          line: 690,
          column: 40
        }
      },
      '296': {
        start: {
          line: 691,
          column: 8
        },
        end: {
          line: 691,
          column: 15
        }
      },
      '297': {
        start: {
          line: 694,
          column: 4
        },
        end: {
          line: 694,
          column: 37
        }
      },
      '298': {
        start: {
          line: 698,
          column: 2
        },
        end: {
          line: 707,
          column: 4
        }
      },
      '299': {
        start: {
          line: 699,
          column: 4
        },
        end: {
          line: 706,
          column: 7
        }
      },
      '300': {
        start: {
          line: 709,
          column: 2
        },
        end: {
          line: 718,
          column: 4
        }
      },
      '301': {
        start: {
          line: 710,
          column: 4
        },
        end: {
          line: 717,
          column: 7
        }
      },
      '302': {
        start: {
          line: 723,
          column: 2
        },
        end: {
          line: 728,
          column: 4
        }
      },
      '303': {
        start: {
          line: 724,
          column: 4
        },
        end: {
          line: 727,
          column: 7
        }
      },
      '304': {
        start: {
          line: 730,
          column: 2
        },
        end: {
          line: 733,
          column: 4
        }
      },
      '305': {
        start: {
          line: 731,
          column: 4
        },
        end: {
          line: 731,
          column: 28
        }
      },
      '306': {
        start: {
          line: 732,
          column: 4
        },
        end: {
          line: 732,
          column: 49
        }
      },
      '307': {
        start: {
          line: 735,
          column: 2
        },
        end: {
          line: 737,
          column: 5
        }
      },
      '308': {
        start: {
          line: 736,
          column: 4
        },
        end: {
          line: 736,
          column: 35
        }
      },
      '309': {
        start: {
          line: 739,
          column: 2
        },
        end: {
          line: 772,
          column: 4
        }
      },
      '310': {
        start: {
          line: 740,
          column: 4
        },
        end: {
          line: 740,
          column: 27
        }
      },
      '311': {
        start: {
          line: 741,
          column: 4
        },
        end: {
          line: 741,
          column: 31
        }
      },
      '312': {
        start: {
          line: 743,
          column: 4
        },
        end: {
          line: 747,
          column: 5
        }
      },
      '313': {
        start: {
          line: 744,
          column: 6
        },
        end: {
          line: 744,
          column: 90
        }
      },
      '314': {
        start: {
          line: 746,
          column: 6
        },
        end: {
          line: 746,
          column: 33
        }
      },
      '315': {
        start: {
          line: 750,
          column: 4
        },
        end: {
          line: 753,
          column: 5
        }
      },
      '316': {
        start: {
          line: 751,
          column: 6
        },
        end: {
          line: 751,
          column: 36
        }
      },
      '317': {
        start: {
          line: 752,
          column: 6
        },
        end: {
          line: 752,
          column: 13
        }
      },
      '318': {
        start: {
          line: 756,
          column: 4
        },
        end: {
          line: 762,
          column: 5
        }
      },
      '319': {
        start: {
          line: 757,
          column: 8
        },
        end: {
          line: 758,
          column: 60
        }
      },
      '320': {
        start: {
          line: 760,
          column: 8
        },
        end: {
          line: 760,
          column: 38
        }
      },
      '321': {
        start: {
          line: 761,
          column: 8
        },
        end: {
          line: 761,
          column: 15
        }
      },
      '322': {
        start: {
          line: 764,
          column: 4
        },
        end: {
          line: 771,
          column: 7
        }
      },
      '323': {
        start: {
          line: 768,
          column: 8
        },
        end: {
          line: 768,
          column: 64
        }
      },
      '324': {
        start: {
          line: 769,
          column: 8
        },
        end: {
          line: 769,
          column: 69
        }
      },
      '325': {
        start: {
          line: 770,
          column: 8
        },
        end: {
          line: 770,
          column: 39
        }
      },
      '326': {
        start: {
          line: 774,
          column: 2
        },
        end: {
          line: 806,
          column: 5
        }
      },
      '327': {
        start: {
          line: 775,
          column: 4
        },
        end: {
          line: 805,
          column: 7
        }
      },
      '328': {
        start: {
          line: 787,
          column: 6
        },
        end: {
          line: 789,
          column: 7
        }
      },
      '329': {
        start: {
          line: 788,
          column: 8
        },
        end: {
          line: 788,
          column: 15
        }
      },
      '330': {
        start: {
          line: 790,
          column: 6
        },
        end: {
          line: 790,
          column: 30
        }
      },
      '331': {
        start: {
          line: 791,
          column: 27
        },
        end: {
          line: 793,
          column: 7
        }
      },
      '332': {
        start: {
          line: 794,
          column: 6
        },
        end: {
          line: 804,
          column: 9
        }
      },
      '333': {
        start: {
          line: 795,
          column: 8
        },
        end: {
          line: 802,
          column: 9
        }
      },
      '334': {
        start: {
          line: 796,
          column: 10
        },
        end: {
          line: 799,
          column: 13
        }
      },
      '335': {
        start: {
          line: 800,
          column: 10
        },
        end: {
          line: 800,
          column: 35
        }
      },
      '336': {
        start: {
          line: 801,
          column: 10
        },
        end: {
          line: 801,
          column: 17
        }
      },
      '337': {
        start: {
          line: 803,
          column: 8
        },
        end: {
          line: 803,
          column: 59
        }
      },
      '338': {
        start: {
          line: 808,
          column: 2
        },
        end: {
          line: 810,
          column: 4
        }
      },
      '339': {
        start: {
          line: 809,
          column: 4
        },
        end: {
          line: 809,
          column: 40
        }
      },
      '340': {
        start: {
          line: 814,
          column: 2
        },
        end: {
          line: 819,
          column: 4
        }
      },
      '341': {
        start: {
          line: 815,
          column: 4
        },
        end: {
          line: 818,
          column: 7
        }
      },
      '342': {
        start: {
          line: 821,
          column: 2
        },
        end: {
          line: 824,
          column: 4
        }
      },
      '343': {
        start: {
          line: 822,
          column: 4
        },
        end: {
          line: 822,
          column: 28
        }
      },
      '344': {
        start: {
          line: 823,
          column: 4
        },
        end: {
          line: 823,
          column: 49
        }
      },
      '345': {
        start: {
          line: 826,
          column: 2
        },
        end: {
          line: 828,
          column: 5
        }
      },
      '346': {
        start: {
          line: 827,
          column: 4
        },
        end: {
          line: 827,
          column: 35
        }
      },
      '347': {
        start: {
          line: 830,
          column: 2
        },
        end: {
          line: 863,
          column: 4
        }
      },
      '348': {
        start: {
          line: 831,
          column: 4
        },
        end: {
          line: 831,
          column: 27
        }
      },
      '349': {
        start: {
          line: 834,
          column: 4
        },
        end: {
          line: 838,
          column: 5
        }
      },
      '350': {
        start: {
          line: 835,
          column: 8
        },
        end: {
          line: 835,
          column: 92
        }
      },
      '351': {
        start: {
          line: 837,
          column: 8
        },
        end: {
          line: 837,
          column: 35
        }
      },
      '352': {
        start: {
          line: 841,
          column: 4
        },
        end: {
          line: 844,
          column: 5
        }
      },
      '353': {
        start: {
          line: 842,
          column: 8
        },
        end: {
          line: 842,
          column: 38
        }
      },
      '354': {
        start: {
          line: 843,
          column: 8
        },
        end: {
          line: 843,
          column: 15
        }
      },
      '355': {
        start: {
          line: 847,
          column: 4
        },
        end: {
          line: 853,
          column: 5
        }
      },
      '356': {
        start: {
          line: 848,
          column: 8
        },
        end: {
          line: 849,
          column: 60
        }
      },
      '357': {
        start: {
          line: 851,
          column: 8
        },
        end: {
          line: 851,
          column: 38
        }
      },
      '358': {
        start: {
          line: 852,
          column: 8
        },
        end: {
          line: 852,
          column: 15
        }
      },
      '359': {
        start: {
          line: 855,
          column: 4
        },
        end: {
          line: 862,
          column: 7
        }
      },
      '360': {
        start: {
          line: 859,
          column: 8
        },
        end: {
          line: 859,
          column: 64
        }
      },
      '361': {
        start: {
          line: 860,
          column: 8
        },
        end: {
          line: 860,
          column: 69
        }
      },
      '362': {
        start: {
          line: 861,
          column: 8
        },
        end: {
          line: 861,
          column: 39
        }
      },
      '363': {
        start: {
          line: 865,
          column: 2
        },
        end: {
          line: 896,
          column: 5
        }
      },
      '364': {
        start: {
          line: 866,
          column: 4
        },
        end: {
          line: 895,
          column: 7
        }
      },
      '365': {
        start: {
          line: 877,
          column: 6
        },
        end: {
          line: 879,
          column: 7
        }
      },
      '366': {
        start: {
          line: 878,
          column: 8
        },
        end: {
          line: 878,
          column: 15
        }
      },
      '367': {
        start: {
          line: 880,
          column: 6
        },
        end: {
          line: 880,
          column: 30
        }
      },
      '368': {
        start: {
          line: 881,
          column: 27
        },
        end: {
          line: 883,
          column: 7
        }
      },
      '369': {
        start: {
          line: 884,
          column: 6
        },
        end: {
          line: 894,
          column: 9
        }
      },
      '370': {
        start: {
          line: 885,
          column: 8
        },
        end: {
          line: 892,
          column: 9
        }
      },
      '371': {
        start: {
          line: 886,
          column: 10
        },
        end: {
          line: 889,
          column: 13
        }
      },
      '372': {
        start: {
          line: 890,
          column: 10
        },
        end: {
          line: 890,
          column: 35
        }
      },
      '373': {
        start: {
          line: 891,
          column: 10
        },
        end: {
          line: 891,
          column: 17
        }
      },
      '374': {
        start: {
          line: 893,
          column: 8
        },
        end: {
          line: 893,
          column: 59
        }
      },
      '375': {
        start: {
          line: 898,
          column: 2
        },
        end: {
          line: 900,
          column: 4
        }
      },
      '376': {
        start: {
          line: 899,
          column: 4
        },
        end: {
          line: 899,
          column: 40
        }
      }
    },
    fnMap: {
      '0': {
        name: 'milestone_edit',
        decl: {
          start: {
            line: 5,
            column: 9
          },
          end: {
            line: 5,
            column: 23
          }
        },
        loc: {
          start: {
            line: 5,
            column: 86
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 5
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 10,
            column: 3
          }
        },
        line: 7
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 11,
            column: 22
          },
          end: {
            line: 11,
            column: 23
          }
        },
        loc: {
          start: {
            line: 11,
            column: 34
          },
          end: {
            line: 13,
            column: 3
          }
        },
        line: 11
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 15,
            column: 48
          },
          end: {
            line: 15,
            column: 49
          }
        },
        loc: {
          start: {
            line: 15,
            column: 305
          },
          end: {
            line: 721,
            column: 1
          }
        },
        line: 15
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 18,
            column: 37
          },
          end: {
            line: 18,
            column: 38
          }
        },
        loc: {
          start: {
            line: 18,
            column: 43
          },
          end: {
            line: 21,
            column: 3
          }
        },
        line: 18
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 24,
            column: 25
          },
          end: {
            line: 24,
            column: 26
          }
        },
        loc: {
          start: {
            line: 24,
            column: 44
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 24
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 37,
            column: 80
          },
          end: {
            line: 37,
            column: 81
          }
        },
        loc: {
          start: {
            line: 37,
            column: 88
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 37
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 44,
            column: 23
          },
          end: {
            line: 44,
            column: 24
          }
        },
        loc: {
          start: {
            line: 44,
            column: 35
          },
          end: {
            line: 51,
            column: 3
          }
        },
        line: 44
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 72,
            column: 23
          },
          end: {
            line: 72,
            column: 24
          }
        },
        loc: {
          start: {
            line: 72,
            column: 33
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 72
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 99,
            column: 18
          },
          end: {
            line: 99,
            column: 19
          }
        },
        loc: {
          start: {
            line: 99,
            column: 30
          },
          end: {
            line: 211,
            column: 3
          }
        },
        line: 99
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 104,
            column: 81
          },
          end: {
            line: 104,
            column: 82
          }
        },
        loc: {
          start: {
            line: 104,
            column: 90
          },
          end: {
            line: 210,
            column: 5
          }
        },
        line: 104
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 214,
            column: 18
          },
          end: {
            line: 214,
            column: 19
          }
        },
        loc: {
          start: {
            line: 214,
            column: 30
          },
          end: {
            line: 216,
            column: 3
          }
        },
        line: 214
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 217,
            column: 20
          },
          end: {
            line: 217,
            column: 21
          }
        },
        loc: {
          start: {
            line: 217,
            column: 32
          },
          end: {
            line: 319,
            column: 3
          }
        },
        line: 217
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 224,
            column: 65
          },
          end: {
            line: 224,
            column: 66
          }
        },
        loc: {
          start: {
            line: 224,
            column: 74
          },
          end: {
            line: 224,
            column: 82
          }
        },
        line: 224
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 309,
            column: 9
          },
          end: {
            line: 309,
            column: 10
          }
        },
        loc: {
          start: {
            line: 309,
            column: 22
          },
          end: {
            line: 314,
            column: 7
          }
        },
        line: 309
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 321,
            column: 30
          },
          end: {
            line: 321,
            column: 31
          }
        },
        loc: {
          start: {
            line: 321,
            column: 36
          },
          end: {
            line: 338,
            column: 3
          }
        },
        line: 321
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 332,
            column: 9
          },
          end: {
            line: 332,
            column: 10
          }
        },
        loc: {
          start: {
            line: 332,
            column: 22
          },
          end: {
            line: 336,
            column: 7
          }
        },
        line: 332
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 340,
            column: 53
          },
          end: {
            line: 340,
            column: 54
          }
        },
        loc: {
          start: {
            line: 340,
            column: 61
          },
          end: {
            line: 351,
            column: 3
          }
        },
        line: 340
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 352,
            column: 25
          },
          end: {
            line: 352,
            column: 26
          }
        },
        loc: {
          start: {
            line: 352,
            column: 49
          },
          end: {
            line: 391,
            column: 3
          }
        },
        line: 352
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 355,
            column: 108
          },
          end: {
            line: 355,
            column: 109
          }
        },
        loc: {
          start: {
            line: 355,
            column: 118
          },
          end: {
            line: 390,
            column: 5
          }
        },
        line: 355
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 374,
            column: 15
          },
          end: {
            line: 374,
            column: 16
          }
        },
        loc: {
          start: {
            line: 374,
            column: 24
          },
          end: {
            line: 378,
            column: 11
          }
        },
        line: 374
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 384,
            column: 130
          },
          end: {
            line: 384,
            column: 131
          }
        },
        loc: {
          start: {
            line: 384,
            column: 139
          },
          end: {
            line: 386,
            column: 9
          }
        },
        line: 384
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 393,
            column: 16
          },
          end: {
            line: 393,
            column: 17
          }
        },
        loc: {
          start: {
            line: 393,
            column: 32
          },
          end: {
            line: 480,
            column: 3
          }
        },
        line: 393
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 406,
            column: 73
          },
          end: {
            line: 406,
            column: 74
          }
        },
        loc: {
          start: {
            line: 406,
            column: 82
          },
          end: {
            line: 408,
            column: 7
          }
        },
        line: 406
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 442,
            column: 67
          },
          end: {
            line: 442,
            column: 68
          }
        },
        loc: {
          start: {
            line: 442,
            column: 75
          },
          end: {
            line: 444,
            column: 7
          }
        },
        line: 442
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 447,
            column: 84
          },
          end: {
            line: 447,
            column: 85
          }
        },
        loc: {
          start: {
            line: 447,
            column: 92
          },
          end: {
            line: 456,
            column: 5
          }
        },
        line: 447
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 461,
            column: 86
          },
          end: {
            line: 461,
            column: 87
          }
        },
        loc: {
          start: {
            line: 461,
            column: 94
          },
          end: {
            line: 463,
            column: 5
          }
        },
        line: 461
      },
      '27': {
        name: '(anonymous_27)',
        decl: {
          start: {
            line: 467,
            column: 62
          },
          end: {
            line: 467,
            column: 63
          }
        },
        loc: {
          start: {
            line: 467,
            column: 70
          },
          end: {
            line: 479,
            column: 5
          }
        },
        line: 467
      },
      '28': {
        name: '(anonymous_28)',
        decl: {
          start: {
            line: 481,
            column: 22
          },
          end: {
            line: 481,
            column: 23
          }
        },
        loc: {
          start: {
            line: 481,
            column: 38
          },
          end: {
            line: 527,
            column: 3
          }
        },
        line: 481
      },
      '29': {
        name: '(anonymous_29)',
        decl: {
          start: {
            line: 493,
            column: 7
          },
          end: {
            line: 493,
            column: 8
          }
        },
        loc: {
          start: {
            line: 493,
            column: 20
          },
          end: {
            line: 526,
            column: 5
          }
        },
        line: 493
      },
      '30': {
        name: '(anonymous_30)',
        decl: {
          start: {
            line: 515,
            column: 95
          },
          end: {
            line: 515,
            column: 96
          }
        },
        loc: {
          start: {
            line: 515,
            column: 103
          },
          end: {
            line: 525,
            column: 7
          }
        },
        line: 515
      },
      '31': {
        name: '(anonymous_31)',
        decl: {
          start: {
            line: 529,
            column: 18
          },
          end: {
            line: 529,
            column: 19
          }
        },
        loc: {
          start: {
            line: 529,
            column: 36
          },
          end: {
            line: 548,
            column: 3
          }
        },
        line: 529
      },
      '32': {
        name: '(anonymous_32)',
        decl: {
          start: {
            line: 532,
            column: 78
          },
          end: {
            line: 532,
            column: 79
          }
        },
        loc: {
          start: {
            line: 532,
            column: 86
          },
          end: {
            line: 547,
            column: 5
          }
        },
        line: 532
      },
      '33': {
        name: '(anonymous_33)',
        decl: {
          start: {
            line: 549,
            column: 24
          },
          end: {
            line: 549,
            column: 25
          }
        },
        loc: {
          start: {
            line: 549,
            column: 36
          },
          end: {
            line: 558,
            column: 3
          }
        },
        line: 549
      },
      '34': {
        name: '(anonymous_34)',
        decl: {
          start: {
            line: 560,
            column: 25
          },
          end: {
            line: 560,
            column: 26
          }
        },
        loc: {
          start: {
            line: 560,
            column: 41
          },
          end: {
            line: 573,
            column: 3
          }
        },
        line: 560
      },
      '35': {
        name: '(anonymous_35)',
        decl: {
          start: {
            line: 574,
            column: 29
          },
          end: {
            line: 574,
            column: 30
          }
        },
        loc: {
          start: {
            line: 574,
            column: 45
          },
          end: {
            line: 592,
            column: 3
          }
        },
        line: 574
      },
      '36': {
        name: '(anonymous_36)',
        decl: {
          start: {
            line: 594,
            column: 27
          },
          end: {
            line: 594,
            column: 28
          }
        },
        loc: {
          start: {
            line: 594,
            column: 43
          },
          end: {
            line: 619,
            column: 3
          }
        },
        line: 594
      },
      '37': {
        name: '(anonymous_37)',
        decl: {
          start: {
            line: 607,
            column: 4
          },
          end: {
            line: 607,
            column: 5
          }
        },
        loc: {
          start: {
            line: 607,
            column: 17
          },
          end: {
            line: 618,
            column: 5
          }
        },
        line: 607
      },
      '38': {
        name: '(anonymous_38)',
        decl: {
          start: {
            line: 624,
            column: 55
          },
          end: {
            line: 624,
            column: 56
          }
        },
        loc: {
          start: {
            line: 624,
            column: 63
          },
          end: {
            line: 630,
            column: 3
          }
        },
        line: 624
      },
      '39': {
        name: '(anonymous_39)',
        decl: {
          start: {
            line: 641,
            column: 31
          },
          end: {
            line: 641,
            column: 32
          }
        },
        loc: {
          start: {
            line: 641,
            column: 66
          },
          end: {
            line: 645,
            column: 3
          }
        },
        line: 641
      },
      '40': {
        name: '(anonymous_40)',
        decl: {
          start: {
            line: 647,
            column: 27
          },
          end: {
            line: 647,
            column: 28
          }
        },
        loc: {
          start: {
            line: 647,
            column: 74
          },
          end: {
            line: 650,
            column: 3
          }
        },
        line: 647
      },
      '41': {
        name: '(anonymous_41)',
        decl: {
          start: {
            line: 652,
            column: 61
          },
          end: {
            line: 652,
            column: 62
          }
        },
        loc: {
          start: {
            line: 652,
            column: 69
          },
          end: {
            line: 655,
            column: 3
          }
        },
        line: 652
      },
      '42': {
        name: '(anonymous_42)',
        decl: {
          start: {
            line: 657,
            column: 61
          },
          end: {
            line: 657,
            column: 62
          }
        },
        loc: {
          start: {
            line: 657,
            column: 69
          },
          end: {
            line: 659,
            column: 3
          }
        },
        line: 657
      },
      '43': {
        name: '(anonymous_43)',
        decl: {
          start: {
            line: 661,
            column: 27
          },
          end: {
            line: 661,
            column: 28
          }
        },
        loc: {
          start: {
            line: 661,
            column: 49
          },
          end: {
            line: 677,
            column: 3
          }
        },
        line: 661
      },
      '44': {
        name: '(anonymous_44)',
        decl: {
          start: {
            line: 664,
            column: 59
          },
          end: {
            line: 664,
            column: 60
          }
        },
        loc: {
          start: {
            line: 664,
            column: 75
          },
          end: {
            line: 666,
            column: 7
          }
        },
        line: 664
      },
      '45': {
        name: '(anonymous_45)',
        decl: {
          start: {
            line: 679,
            column: 27
          },
          end: {
            line: 679,
            column: 28
          }
        },
        loc: {
          start: {
            line: 679,
            column: 49
          },
          end: {
            line: 695,
            column: 3
          }
        },
        line: 679
      },
      '46': {
        name: '(anonymous_46)',
        decl: {
          start: {
            line: 682,
            column: 59
          },
          end: {
            line: 682,
            column: 60
          }
        },
        loc: {
          start: {
            line: 682,
            column: 75
          },
          end: {
            line: 684,
            column: 7
          }
        },
        line: 682
      },
      '47': {
        name: '(anonymous_47)',
        decl: {
          start: {
            line: 698,
            column: 29
          },
          end: {
            line: 698,
            column: 30
          }
        },
        loc: {
          start: {
            line: 698,
            column: 41
          },
          end: {
            line: 707,
            column: 3
          }
        },
        line: 698
      },
      '48': {
        name: '(anonymous_48)',
        decl: {
          start: {
            line: 709,
            column: 29
          },
          end: {
            line: 709,
            column: 30
          }
        },
        loc: {
          start: {
            line: 709,
            column: 41
          },
          end: {
            line: 718,
            column: 3
          }
        },
        line: 709
      },
      '49': {
        name: 'Personnalize_1_Ctrl_Project_edit',
        decl: {
          start: {
            line: 722,
            column: 9
          },
          end: {
            line: 722,
            column: 41
          }
        },
        loc: {
          start: {
            line: 722,
            column: 116
          },
          end: {
            line: 811,
            column: 1
          }
        },
        line: 722
      },
      '50': {
        name: '(anonymous_50)',
        decl: {
          start: {
            line: 723,
            column: 23
          },
          end: {
            line: 723,
            column: 24
          }
        },
        loc: {
          start: {
            line: 723,
            column: 35
          },
          end: {
            line: 728,
            column: 3
          }
        },
        line: 723
      },
      '51': {
        name: '(anonymous_51)',
        decl: {
          start: {
            line: 730,
            column: 24
          },
          end: {
            line: 730,
            column: 25
          }
        },
        loc: {
          start: {
            line: 730,
            column: 40
          },
          end: {
            line: 733,
            column: 3
          }
        },
        line: 730
      },
      '52': {
        name: '(anonymous_52)',
        decl: {
          start: {
            line: 735,
            column: 27
          },
          end: {
            line: 735,
            column: 28
          }
        },
        loc: {
          start: {
            line: 735,
            column: 33
          },
          end: {
            line: 737,
            column: 3
          }
        },
        line: 735
      },
      '53': {
        name: '(anonymous_53)',
        decl: {
          start: {
            line: 739,
            column: 28
          },
          end: {
            line: 739,
            column: 29
          }
        },
        loc: {
          start: {
            line: 739,
            column: 39
          },
          end: {
            line: 772,
            column: 3
          }
        },
        line: 739
      },
      '54': {
        name: '(anonymous_54)',
        decl: {
          start: {
            line: 756,
            column: 37
          },
          end: {
            line: 756,
            column: 38
          }
        },
        loc: {
          start: {
            line: 756,
            column: 49
          },
          end: {
            line: 759,
            column: 5
          }
        },
        line: 756
      },
      '55': {
        name: '(anonymous_55)',
        decl: {
          start: {
            line: 767,
            column: 7
          },
          end: {
            line: 767,
            column: 8
          }
        },
        loc: {
          start: {
            line: 767,
            column: 15
          },
          end: {
            line: 771,
            column: 5
          }
        },
        line: 767
      },
      '56': {
        name: '(anonymous_56)',
        decl: {
          start: {
            line: 774,
            column: 27
          },
          end: {
            line: 774,
            column: 28
          }
        },
        loc: {
          start: {
            line: 774,
            column: 35
          },
          end: {
            line: 806,
            column: 3
          }
        },
        line: 774
      },
      '57': {
        name: '(anonymous_57)',
        decl: {
          start: {
            line: 786,
            column: 7
          },
          end: {
            line: 786,
            column: 8
          }
        },
        loc: {
          start: {
            line: 786,
            column: 20
          },
          end: {
            line: 805,
            column: 5
          }
        },
        line: 786
      },
      '58': {
        name: '(anonymous_58)',
        decl: {
          start: {
            line: 794,
            column: 81
          },
          end: {
            line: 794,
            column: 82
          }
        },
        loc: {
          start: {
            line: 794,
            column: 89
          },
          end: {
            line: 804,
            column: 7
          }
        },
        line: 794
      },
      '59': {
        name: '(anonymous_59)',
        decl: {
          start: {
            line: 808,
            column: 22
          },
          end: {
            line: 808,
            column: 23
          }
        },
        loc: {
          start: {
            line: 808,
            column: 34
          },
          end: {
            line: 810,
            column: 3
          }
        },
        line: 808
      },
      '60': {
        name: 'Personnalize_2_Ctrl_Project_edit',
        decl: {
          start: {
            line: 813,
            column: 9
          },
          end: {
            line: 813,
            column: 41
          }
        },
        loc: {
          start: {
            line: 813,
            column: 116
          },
          end: {
            line: 901,
            column: 1
          }
        },
        line: 813
      },
      '61': {
        name: '(anonymous_61)',
        decl: {
          start: {
            line: 814,
            column: 23
          },
          end: {
            line: 814,
            column: 24
          }
        },
        loc: {
          start: {
            line: 814,
            column: 35
          },
          end: {
            line: 819,
            column: 3
          }
        },
        line: 814
      },
      '62': {
        name: '(anonymous_62)',
        decl: {
          start: {
            line: 821,
            column: 24
          },
          end: {
            line: 821,
            column: 25
          }
        },
        loc: {
          start: {
            line: 821,
            column: 40
          },
          end: {
            line: 824,
            column: 3
          }
        },
        line: 821
      },
      '63': {
        name: '(anonymous_63)',
        decl: {
          start: {
            line: 826,
            column: 27
          },
          end: {
            line: 826,
            column: 28
          }
        },
        loc: {
          start: {
            line: 826,
            column: 33
          },
          end: {
            line: 828,
            column: 3
          }
        },
        line: 826
      },
      '64': {
        name: '(anonymous_64)',
        decl: {
          start: {
            line: 830,
            column: 28
          },
          end: {
            line: 830,
            column: 29
          }
        },
        loc: {
          start: {
            line: 830,
            column: 39
          },
          end: {
            line: 863,
            column: 3
          }
        },
        line: 830
      },
      '65': {
        name: '(anonymous_65)',
        decl: {
          start: {
            line: 847,
            column: 37
          },
          end: {
            line: 847,
            column: 38
          }
        },
        loc: {
          start: {
            line: 847,
            column: 49
          },
          end: {
            line: 850,
            column: 5
          }
        },
        line: 847
      },
      '66': {
        name: '(anonymous_66)',
        decl: {
          start: {
            line: 858,
            column: 7
          },
          end: {
            line: 858,
            column: 8
          }
        },
        loc: {
          start: {
            line: 858,
            column: 15
          },
          end: {
            line: 862,
            column: 5
          }
        },
        line: 858
      },
      '67': {
        name: '(anonymous_67)',
        decl: {
          start: {
            line: 865,
            column: 27
          },
          end: {
            line: 865,
            column: 28
          }
        },
        loc: {
          start: {
            line: 865,
            column: 35
          },
          end: {
            line: 896,
            column: 3
          }
        },
        line: 865
      },
      '68': {
        name: '(anonymous_68)',
        decl: {
          start: {
            line: 876,
            column: 7
          },
          end: {
            line: 876,
            column: 8
          }
        },
        loc: {
          start: {
            line: 876,
            column: 20
          },
          end: {
            line: 895,
            column: 5
          }
        },
        line: 876
      },
      '69': {
        name: '(anonymous_69)',
        decl: {
          start: {
            line: 884,
            column: 81
          },
          end: {
            line: 884,
            column: 82
          }
        },
        loc: {
          start: {
            line: 884,
            column: 89
          },
          end: {
            line: 894,
            column: 7
          }
        },
        line: 884
      },
      '70': {
        name: '(anonymous_70)',
        decl: {
          start: {
            line: 898,
            column: 22
          },
          end: {
            line: 898,
            column: 23
          }
        },
        loc: {
          start: {
            line: 898,
            column: 34
          },
          end: {
            line: 900,
            column: 3
          }
        },
        line: 898
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 25,
            column: 29
          },
          end: {
            line: 25,
            column: 47
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 25,
            column: 29
          },
          end: {
            line: 25,
            column: 36
          }
        }, {
          start: {
            line: 25,
            column: 40
          },
          end: {
            line: 25,
            column: 47
          }
        }],
        line: 25
      },
      '1': {
        loc: {
          start: {
            line: 47,
            column: 16
          },
          end: {
            line: 47,
            column: 75
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 47,
            column: 16
          },
          end: {
            line: 47,
            column: 51
          }
        }, {
          start: {
            line: 47,
            column: 55
          },
          end: {
            line: 47,
            column: 75
          }
        }],
        line: 47
      },
      '2': {
        loc: {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }, {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }],
        line: 73
      },
      '3': {
        loc: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }],
        line: 76
      },
      '4': {
        loc: {
          start: {
            line: 105,
            column: 17
          },
          end: {
            line: 105,
            column: 52
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 105,
            column: 37
          },
          end: {
            line: 105,
            column: 41
          }
        }, {
          start: {
            line: 105,
            column: 44
          },
          end: {
            line: 105,
            column: 52
          }
        }],
        line: 105
      },
      '5': {
        loc: {
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 208,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 208,
            column: 7
          }
        }, {
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 208,
            column: 7
          }
        }],
        line: 108
      },
      '6': {
        loc: {
          start: {
            line: 181,
            column: 40
          },
          end: {
            line: 181,
            column: 69
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 181,
            column: 40
          },
          end: {
            line: 181,
            column: 56
          }
        }, {
          start: {
            line: 181,
            column: 60
          },
          end: {
            line: 181,
            column: 69
          }
        }],
        line: 181
      },
      '7': {
        loc: {
          start: {
            line: 185,
            column: 8
          },
          end: {
            line: 187,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 185,
            column: 8
          },
          end: {
            line: 187,
            column: 9
          }
        }, {
          start: {
            line: 185,
            column: 8
          },
          end: {
            line: 187,
            column: 9
          }
        }],
        line: 185
      },
      '8': {
        loc: {
          start: {
            line: 188,
            column: 8
          },
          end: {
            line: 190,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 188,
            column: 8
          },
          end: {
            line: 190,
            column: 9
          }
        }, {
          start: {
            line: 188,
            column: 8
          },
          end: {
            line: 190,
            column: 9
          }
        }],
        line: 188
      },
      '9': {
        loc: {
          start: {
            line: 225,
            column: 33
          },
          end: {
            line: 225,
            column: 112
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 225,
            column: 107
          },
          end: {
            line: 225,
            column: 108
          }
        }, {
          start: {
            line: 225,
            column: 111
          },
          end: {
            line: 225,
            column: 112
          }
        }],
        line: 225
      },
      '10': {
        loc: {
          start: {
            line: 225,
            column: 34
          },
          end: {
            line: 225,
            column: 103
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 225,
            column: 34
          },
          end: {
            line: 225,
            column: 66
          }
        }, {
          start: {
            line: 225,
            column: 70
          },
          end: {
            line: 225,
            column: 103
          }
        }],
        line: 225
      },
      '11': {
        loc: {
          start: {
            line: 227,
            column: 31
          },
          end: {
            line: 227,
            column: 70
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 227,
            column: 65
          },
          end: {
            line: 227,
            column: 66
          }
        }, {
          start: {
            line: 227,
            column: 69
          },
          end: {
            line: 227,
            column: 70
          }
        }],
        line: 227
      },
      '12': {
        loc: {
          start: {
            line: 228,
            column: 35
          },
          end: {
            line: 228,
            column: 78
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 228,
            column: 73
          },
          end: {
            line: 228,
            column: 74
          }
        }, {
          start: {
            line: 228,
            column: 77
          },
          end: {
            line: 228,
            column: 78
          }
        }],
        line: 228
      },
      '13': {
        loc: {
          start: {
            line: 229,
            column: 38
          },
          end: {
            line: 229,
            column: 125
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 229,
            column: 120
          },
          end: {
            line: 229,
            column: 121
          }
        }, {
          start: {
            line: 229,
            column: 124
          },
          end: {
            line: 229,
            column: 125
          }
        }],
        line: 229
      },
      '14': {
        loc: {
          start: {
            line: 229,
            column: 39
          },
          end: {
            line: 229,
            column: 116
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 229,
            column: 39
          },
          end: {
            line: 229,
            column: 74
          }
        }, {
          start: {
            line: 229,
            column: 78
          },
          end: {
            line: 229,
            column: 116
          }
        }],
        line: 229
      },
      '15': {
        loc: {
          start: {
            line: 230,
            column: 32
          },
          end: {
            line: 230,
            column: 72
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 230,
            column: 67
          },
          end: {
            line: 230,
            column: 68
          }
        }, {
          start: {
            line: 230,
            column: 71
          },
          end: {
            line: 230,
            column: 72
          }
        }],
        line: 230
      },
      '16': {
        loc: {
          start: {
            line: 232,
            column: 38
          },
          end: {
            line: 232,
            column: 84
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 232,
            column: 79
          },
          end: {
            line: 232,
            column: 80
          }
        }, {
          start: {
            line: 232,
            column: 83
          },
          end: {
            line: 232,
            column: 84
          }
        }],
        line: 232
      },
      '17': {
        loc: {
          start: {
            line: 233,
            column: 48
          },
          end: {
            line: 233,
            column: 104
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 233,
            column: 99
          },
          end: {
            line: 233,
            column: 100
          }
        }, {
          start: {
            line: 233,
            column: 103
          },
          end: {
            line: 233,
            column: 104
          }
        }],
        line: 233
      },
      '18': {
        loc: {
          start: {
            line: 234,
            column: 32
          },
          end: {
            line: 234,
            column: 72
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 234,
            column: 67
          },
          end: {
            line: 234,
            column: 68
          }
        }, {
          start: {
            line: 234,
            column: 71
          },
          end: {
            line: 234,
            column: 72
          }
        }],
        line: 234
      },
      '19': {
        loc: {
          start: {
            line: 235,
            column: 28
          },
          end: {
            line: 235,
            column: 64
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 235,
            column: 59
          },
          end: {
            line: 235,
            column: 60
          }
        }, {
          start: {
            line: 235,
            column: 63
          },
          end: {
            line: 235,
            column: 64
          }
        }],
        line: 235
      },
      '20': {
        loc: {
          start: {
            line: 236,
            column: 24
          },
          end: {
            line: 236,
            column: 56
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 236,
            column: 51
          },
          end: {
            line: 236,
            column: 52
          }
        }, {
          start: {
            line: 236,
            column: 55
          },
          end: {
            line: 236,
            column: 56
          }
        }],
        line: 236
      },
      '21': {
        loc: {
          start: {
            line: 237,
            column: 27
          },
          end: {
            line: 237,
            column: 62
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 237,
            column: 57
          },
          end: {
            line: 237,
            column: 58
          }
        }, {
          start: {
            line: 237,
            column: 61
          },
          end: {
            line: 237,
            column: 62
          }
        }],
        line: 237
      },
      '22': {
        loc: {
          start: {
            line: 238,
            column: 30
          },
          end: {
            line: 238,
            column: 68
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 238,
            column: 63
          },
          end: {
            line: 238,
            column: 64
          }
        }, {
          start: {
            line: 238,
            column: 67
          },
          end: {
            line: 238,
            column: 68
          }
        }],
        line: 238
      },
      '23': {
        loc: {
          start: {
            line: 239,
            column: 30
          },
          end: {
            line: 239,
            column: 68
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 239,
            column: 63
          },
          end: {
            line: 239,
            column: 64
          }
        }, {
          start: {
            line: 239,
            column: 67
          },
          end: {
            line: 239,
            column: 68
          }
        }],
        line: 239
      },
      '24': {
        loc: {
          start: {
            line: 241,
            column: 27
          },
          end: {
            line: 241,
            column: 62
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 241,
            column: 57
          },
          end: {
            line: 241,
            column: 58
          }
        }, {
          start: {
            line: 241,
            column: 61
          },
          end: {
            line: 241,
            column: 62
          }
        }],
        line: 241
      },
      '25': {
        loc: {
          start: {
            line: 249,
            column: 9
          },
          end: {
            line: 249,
            column: 47
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 249,
            column: 38
          },
          end: {
            line: 249,
            column: 41
          }
        }, {
          start: {
            line: 249,
            column: 44
          },
          end: {
            line: 249,
            column: 47
          }
        }],
        line: 249
      },
      '26': {
        loc: {
          start: {
            line: 250,
            column: 10
          },
          end: {
            line: 250,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 250,
            column: 40
          },
          end: {
            line: 250,
            column: 43
          }
        }, {
          start: {
            line: 250,
            column: 46
          },
          end: {
            line: 250,
            column: 49
          }
        }],
        line: 250
      },
      '27': {
        loc: {
          start: {
            line: 251,
            column: 10
          },
          end: {
            line: 251,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 251,
            column: 40
          },
          end: {
            line: 251,
            column: 43
          }
        }, {
          start: {
            line: 251,
            column: 46
          },
          end: {
            line: 251,
            column: 49
          }
        }],
        line: 251
      },
      '28': {
        loc: {
          start: {
            line: 252,
            column: 10
          },
          end: {
            line: 252,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 252,
            column: 40
          },
          end: {
            line: 252,
            column: 43
          }
        }, {
          start: {
            line: 252,
            column: 46
          },
          end: {
            line: 252,
            column: 49
          }
        }],
        line: 252
      },
      '29': {
        loc: {
          start: {
            line: 253,
            column: 9
          },
          end: {
            line: 253,
            column: 47
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 253,
            column: 38
          },
          end: {
            line: 253,
            column: 41
          }
        }, {
          start: {
            line: 253,
            column: 44
          },
          end: {
            line: 253,
            column: 47
          }
        }],
        line: 253
      },
      '30': {
        loc: {
          start: {
            line: 254,
            column: 10
          },
          end: {
            line: 254,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 254,
            column: 40
          },
          end: {
            line: 254,
            column: 43
          }
        }, {
          start: {
            line: 254,
            column: 46
          },
          end: {
            line: 254,
            column: 49
          }
        }],
        line: 254
      },
      '31': {
        loc: {
          start: {
            line: 255,
            column: 10
          },
          end: {
            line: 255,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 255,
            column: 40
          },
          end: {
            line: 255,
            column: 43
          }
        }, {
          start: {
            line: 255,
            column: 46
          },
          end: {
            line: 255,
            column: 49
          }
        }],
        line: 255
      },
      '32': {
        loc: {
          start: {
            line: 256,
            column: 10
          },
          end: {
            line: 256,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 256,
            column: 40
          },
          end: {
            line: 256,
            column: 43
          }
        }, {
          start: {
            line: 256,
            column: 46
          },
          end: {
            line: 256,
            column: 49
          }
        }],
        line: 256
      },
      '33': {
        loc: {
          start: {
            line: 257,
            column: 10
          },
          end: {
            line: 257,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 257,
            column: 40
          },
          end: {
            line: 257,
            column: 43
          }
        }, {
          start: {
            line: 257,
            column: 46
          },
          end: {
            line: 257,
            column: 49
          }
        }],
        line: 257
      },
      '34': {
        loc: {
          start: {
            line: 266,
            column: 6
          },
          end: {
            line: 276,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 266,
            column: 6
          },
          end: {
            line: 276,
            column: 7
          }
        }, {
          start: {
            line: 266,
            column: 6
          },
          end: {
            line: 276,
            column: 7
          }
        }],
        line: 266
      },
      '35': {
        loc: {
          start: {
            line: 268,
            column: 8
          },
          end: {
            line: 275,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 268,
            column: 8
          },
          end: {
            line: 275,
            column: 9
          }
        }, {
          start: {
            line: 268,
            column: 8
          },
          end: {
            line: 275,
            column: 9
          }
        }],
        line: 268
      },
      '36': {
        loc: {
          start: {
            line: 268,
            column: 12
          },
          end: {
            line: 268,
            column: 80
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 268,
            column: 12
          },
          end: {
            line: 268,
            column: 38
          }
        }, {
          start: {
            line: 268,
            column: 42
          },
          end: {
            line: 268,
            column: 80
          }
        }],
        line: 268
      },
      '37': {
        loc: {
          start: {
            line: 278,
            column: 4
          },
          end: {
            line: 285,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 278,
            column: 4
          },
          end: {
            line: 285,
            column: 5
          }
        }, {
          start: {
            line: 278,
            column: 4
          },
          end: {
            line: 285,
            column: 5
          }
        }],
        line: 278
      },
      '38': {
        loc: {
          start: {
            line: 286,
            column: 4
          },
          end: {
            line: 293,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 286,
            column: 4
          },
          end: {
            line: 293,
            column: 5
          }
        }, {
          start: {
            line: 286,
            column: 4
          },
          end: {
            line: 293,
            column: 5
          }
        }],
        line: 286
      },
      '39': {
        loc: {
          start: {
            line: 298,
            column: 4
          },
          end: {
            line: 317,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 298,
            column: 4
          },
          end: {
            line: 317,
            column: 5
          }
        }, {
          start: {
            line: 298,
            column: 4
          },
          end: {
            line: 317,
            column: 5
          }
        }],
        line: 298
      },
      '40': {
        loc: {
          start: {
            line: 298,
            column: 8
          },
          end: {
            line: 298,
            column: 83
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 298,
            column: 8
          },
          end: {
            line: 298,
            column: 59
          }
        }, {
          start: {
            line: 298,
            column: 63
          },
          end: {
            line: 298,
            column: 83
          }
        }],
        line: 298
      },
      '41': {
        loc: {
          start: {
            line: 310,
            column: 8
          },
          end: {
            line: 312,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 310,
            column: 8
          },
          end: {
            line: 312,
            column: 9
          }
        }, {
          start: {
            line: 310,
            column: 8
          },
          end: {
            line: 312,
            column: 9
          }
        }],
        line: 310
      },
      '42': {
        loc: {
          start: {
            line: 322,
            column: 4
          },
          end: {
            line: 337,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 322,
            column: 4
          },
          end: {
            line: 337,
            column: 5
          }
        }, {
          start: {
            line: 322,
            column: 4
          },
          end: {
            line: 337,
            column: 5
          }
        }],
        line: 322
      },
      '43': {
        loc: {
          start: {
            line: 333,
            column: 8
          },
          end: {
            line: 335,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 333,
            column: 8
          },
          end: {
            line: 335,
            column: 9
          }
        }, {
          start: {
            line: 333,
            column: 8
          },
          end: {
            line: 335,
            column: 9
          }
        }],
        line: 333
      },
      '44': {
        loc: {
          start: {
            line: 357,
            column: 6
          },
          end: {
            line: 380,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 357,
            column: 6
          },
          end: {
            line: 380,
            column: 7
          }
        }, {
          start: {
            line: 357,
            column: 6
          },
          end: {
            line: 380,
            column: 7
          }
        }],
        line: 357
      },
      '45': {
        loc: {
          start: {
            line: 361,
            column: 25
          },
          end: {
            line: 361,
            column: 54
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 361,
            column: 25
          },
          end: {
            line: 361,
            column: 48
          }
        }, {
          start: {
            line: 361,
            column: 52
          },
          end: {
            line: 361,
            column: 54
          }
        }],
        line: 361
      },
      '46': {
        loc: {
          start: {
            line: 366,
            column: 30
          },
          end: {
            line: 366,
            column: 55
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 366,
            column: 50
          },
          end: {
            line: 366,
            column: 51
          }
        }, {
          start: {
            line: 366,
            column: 54
          },
          end: {
            line: 366,
            column: 55
          }
        }],
        line: 366
      },
      '47': {
        loc: {
          start: {
            line: 375,
            column: 12
          },
          end: {
            line: 377,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 375,
            column: 12
          },
          end: {
            line: 377,
            column: 13
          }
        }, {
          start: {
            line: 375,
            column: 12
          },
          end: {
            line: 377,
            column: 13
          }
        }],
        line: 375
      },
      '48': {
        loc: {
          start: {
            line: 383,
            column: 6
          },
          end: {
            line: 387,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 383,
            column: 6
          },
          end: {
            line: 387,
            column: 7
          }
        }, {
          start: {
            line: 383,
            column: 6
          },
          end: {
            line: 387,
            column: 7
          }
        }],
        line: 383
      },
      '49': {
        loc: {
          start: {
            line: 383,
            column: 10
          },
          end: {
            line: 383,
            column: 65
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 383,
            column: 11
          },
          end: {
            line: 383,
            column: 30
          }
        }, {
          start: {
            line: 383,
            column: 36
          },
          end: {
            line: 383,
            column: 64
          }
        }],
        line: 383
      },
      '50': {
        loc: {
          start: {
            line: 402,
            column: 89
          },
          end: {
            line: 402,
            column: 116
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 402,
            column: 89
          },
          end: {
            line: 402,
            column: 109
          }
        }, {
          start: {
            line: 402,
            column: 113
          },
          end: {
            line: 402,
            column: 116
          }
        }],
        line: 402
      },
      '51': {
        loc: {
          start: {
            line: 403,
            column: 76
          },
          end: {
            line: 403,
            column: 106
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 403,
            column: 76
          },
          end: {
            line: 403,
            column: 101
          }
        }, {
          start: {
            line: 403,
            column: 105
          },
          end: {
            line: 403,
            column: 106
          }
        }],
        line: 403
      },
      '52': {
        loc: {
          start: {
            line: 405,
            column: 4
          },
          end: {
            line: 413,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 405,
            column: 4
          },
          end: {
            line: 413,
            column: 5
          }
        }, {
          start: {
            line: 405,
            column: 4
          },
          end: {
            line: 413,
            column: 5
          }
        }],
        line: 405
      },
      '53': {
        loc: {
          start: {
            line: 405,
            column: 7
          },
          end: {
            line: 405,
            column: 74
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 405,
            column: 7
          },
          end: {
            line: 405,
            column: 33
          }
        }, {
          start: {
            line: 405,
            column: 37
          },
          end: {
            line: 405,
            column: 74
          }
        }],
        line: 405
      },
      '54': {
        loc: {
          start: {
            line: 410,
            column: 6
          },
          end: {
            line: 412,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 410,
            column: 6
          },
          end: {
            line: 412,
            column: 7
          }
        }, {
          start: {
            line: 410,
            column: 6
          },
          end: {
            line: 412,
            column: 7
          }
        }],
        line: 410
      },
      '55': {
        loc: {
          start: {
            line: 421,
            column: 92
          },
          end: {
            line: 421,
            column: 113
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 421,
            column: 92
          },
          end: {
            line: 421,
            column: 108
          }
        }, {
          start: {
            line: 421,
            column: 112
          },
          end: {
            line: 421,
            column: 113
          }
        }],
        line: 421
      },
      '56': {
        loc: {
          start: {
            line: 441,
            column: 4
          },
          end: {
            line: 445,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 441,
            column: 4
          },
          end: {
            line: 445,
            column: 5
          }
        }, {
          start: {
            line: 441,
            column: 4
          },
          end: {
            line: 445,
            column: 5
          }
        }],
        line: 441
      },
      '57': {
        loc: {
          start: {
            line: 467,
            column: 47
          },
          end: {
            line: 467,
            column: 59
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 467,
            column: 47
          },
          end: {
            line: 467,
            column: 54
          }
        }, {
          start: {
            line: 467,
            column: 58
          },
          end: {
            line: 467,
            column: 59
          }
        }],
        line: 467
      },
      '58': {
        loc: {
          start: {
            line: 469,
            column: 8
          },
          end: {
            line: 471,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 469,
            column: 8
          },
          end: {
            line: 471,
            column: 9
          }
        }, {
          start: {
            line: 469,
            column: 8
          },
          end: {
            line: 471,
            column: 9
          }
        }],
        line: 469
      },
      '59': {
        loc: {
          start: {
            line: 472,
            column: 8
          },
          end: {
            line: 474,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 472,
            column: 8
          },
          end: {
            line: 474,
            column: 9
          }
        }, {
          start: {
            line: 472,
            column: 8
          },
          end: {
            line: 474,
            column: 9
          }
        }],
        line: 472
      },
      '60': {
        loc: {
          start: {
            line: 494,
            column: 6
          },
          end: {
            line: 496,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 494,
            column: 6
          },
          end: {
            line: 496,
            column: 7
          }
        }, {
          start: {
            line: 494,
            column: 6
          },
          end: {
            line: 496,
            column: 7
          }
        }],
        line: 494
      },
      '61': {
        loc: {
          start: {
            line: 516,
            column: 8
          },
          end: {
            line: 523,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 516,
            column: 8
          },
          end: {
            line: 523,
            column: 9
          }
        }, {
          start: {
            line: 516,
            column: 8
          },
          end: {
            line: 523,
            column: 9
          }
        }],
        line: 516
      },
      '62': {
        loc: {
          start: {
            line: 586,
            column: 4
          },
          end: {
            line: 590,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 586,
            column: 4
          },
          end: {
            line: 590,
            column: 5
          }
        }, {
          start: {
            line: 586,
            column: 4
          },
          end: {
            line: 590,
            column: 5
          }
        }],
        line: 586
      },
      '63': {
        loc: {
          start: {
            line: 608,
            column: 6
          },
          end: {
            line: 610,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 608,
            column: 6
          },
          end: {
            line: 610,
            column: 7
          }
        }, {
          start: {
            line: 608,
            column: 6
          },
          end: {
            line: 610,
            column: 7
          }
        }],
        line: 608
      },
      '64': {
        loc: {
          start: {
            line: 612,
            column: 6
          },
          end: {
            line: 617,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 612,
            column: 6
          },
          end: {
            line: 617,
            column: 7
          }
        }, {
          start: {
            line: 612,
            column: 6
          },
          end: {
            line: 617,
            column: 7
          }
        }],
        line: 612
      },
      '65': {
        loc: {
          start: {
            line: 613,
            column: 8
          },
          end: {
            line: 615,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 613,
            column: 8
          },
          end: {
            line: 615,
            column: 9
          }
        }, {
          start: {
            line: 613,
            column: 8
          },
          end: {
            line: 615,
            column: 9
          }
        }],
        line: 613
      },
      '66': {
        loc: {
          start: {
            line: 625,
            column: 4
          },
          end: {
            line: 628,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 625,
            column: 4
          },
          end: {
            line: 628,
            column: 5
          }
        }, {
          start: {
            line: 625,
            column: 4
          },
          end: {
            line: 628,
            column: 5
          }
        }],
        line: 625
      },
      '67': {
        loc: {
          start: {
            line: 662,
            column: 28
          },
          end: {
            line: 662,
            column: 55
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 662,
            column: 28
          },
          end: {
            line: 662,
            column: 49
          }
        }, {
          start: {
            line: 662,
            column: 53
          },
          end: {
            line: 662,
            column: 55
          }
        }],
        line: 662
      },
      '68': {
        loc: {
          start: {
            line: 663,
            column: 4
          },
          end: {
            line: 668,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 663,
            column: 4
          },
          end: {
            line: 668,
            column: 5
          }
        }, {
          start: {
            line: 663,
            column: 4
          },
          end: {
            line: 668,
            column: 5
          }
        }],
        line: 663
      },
      '69': {
        loc: {
          start: {
            line: 670,
            column: 6
          },
          end: {
            line: 674,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 670,
            column: 6
          },
          end: {
            line: 674,
            column: 7
          }
        }, {
          start: {
            line: 670,
            column: 6
          },
          end: {
            line: 674,
            column: 7
          }
        }],
        line: 670
      },
      '70': {
        loc: {
          start: {
            line: 680,
            column: 28
          },
          end: {
            line: 680,
            column: 55
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 680,
            column: 28
          },
          end: {
            line: 680,
            column: 49
          }
        }, {
          start: {
            line: 680,
            column: 53
          },
          end: {
            line: 680,
            column: 55
          }
        }],
        line: 680
      },
      '71': {
        loc: {
          start: {
            line: 681,
            column: 4
          },
          end: {
            line: 686,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 681,
            column: 4
          },
          end: {
            line: 686,
            column: 5
          }
        }, {
          start: {
            line: 681,
            column: 4
          },
          end: {
            line: 686,
            column: 5
          }
        }],
        line: 681
      },
      '72': {
        loc: {
          start: {
            line: 688,
            column: 6
          },
          end: {
            line: 692,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 688,
            column: 6
          },
          end: {
            line: 692,
            column: 7
          }
        }, {
          start: {
            line: 688,
            column: 6
          },
          end: {
            line: 692,
            column: 7
          }
        }],
        line: 688
      },
      '73': {
        loc: {
          start: {
            line: 743,
            column: 4
          },
          end: {
            line: 747,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 743,
            column: 4
          },
          end: {
            line: 747,
            column: 5
          }
        }, {
          start: {
            line: 743,
            column: 4
          },
          end: {
            line: 747,
            column: 5
          }
        }],
        line: 743
      },
      '74': {
        loc: {
          start: {
            line: 743,
            column: 8
          },
          end: {
            line: 743,
            column: 71
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 743,
            column: 8
          },
          end: {
            line: 743,
            column: 30
          }
        }, {
          start: {
            line: 743,
            column: 34
          },
          end: {
            line: 743,
            column: 71
          }
        }],
        line: 743
      },
      '75': {
        loc: {
          start: {
            line: 750,
            column: 4
          },
          end: {
            line: 753,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 750,
            column: 4
          },
          end: {
            line: 753,
            column: 5
          }
        }, {
          start: {
            line: 750,
            column: 4
          },
          end: {
            line: 753,
            column: 5
          }
        }],
        line: 750
      },
      '76': {
        loc: {
          start: {
            line: 750,
            column: 8
          },
          end: {
            line: 750,
            column: 65
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 750,
            column: 8
          },
          end: {
            line: 750,
            column: 32
          }
        }, {
          start: {
            line: 750,
            column: 36
          },
          end: {
            line: 750,
            column: 65
          }
        }],
        line: 750
      },
      '77': {
        loc: {
          start: {
            line: 756,
            column: 4
          },
          end: {
            line: 762,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 756,
            column: 4
          },
          end: {
            line: 762,
            column: 5
          }
        }, {
          start: {
            line: 756,
            column: 4
          },
          end: {
            line: 762,
            column: 5
          }
        }],
        line: 756
      },
      '78': {
        loc: {
          start: {
            line: 757,
            column: 15
          },
          end: {
            line: 758,
            column: 59
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 757,
            column: 15
          },
          end: {
            line: 757,
            column: 89
          }
        }, {
          start: {
            line: 758,
            column: 18
          },
          end: {
            line: 758,
            column: 59
          }
        }],
        line: 757
      },
      '79': {
        loc: {
          start: {
            line: 787,
            column: 6
          },
          end: {
            line: 789,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 787,
            column: 6
          },
          end: {
            line: 789,
            column: 7
          }
        }, {
          start: {
            line: 787,
            column: 6
          },
          end: {
            line: 789,
            column: 7
          }
        }],
        line: 787
      },
      '80': {
        loc: {
          start: {
            line: 795,
            column: 8
          },
          end: {
            line: 802,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 795,
            column: 8
          },
          end: {
            line: 802,
            column: 9
          }
        }, {
          start: {
            line: 795,
            column: 8
          },
          end: {
            line: 802,
            column: 9
          }
        }],
        line: 795
      },
      '81': {
        loc: {
          start: {
            line: 834,
            column: 4
          },
          end: {
            line: 838,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 834,
            column: 4
          },
          end: {
            line: 838,
            column: 5
          }
        }, {
          start: {
            line: 834,
            column: 4
          },
          end: {
            line: 838,
            column: 5
          }
        }],
        line: 834
      },
      '82': {
        loc: {
          start: {
            line: 834,
            column: 8
          },
          end: {
            line: 834,
            column: 71
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 834,
            column: 8
          },
          end: {
            line: 834,
            column: 30
          }
        }, {
          start: {
            line: 834,
            column: 34
          },
          end: {
            line: 834,
            column: 71
          }
        }],
        line: 834
      },
      '83': {
        loc: {
          start: {
            line: 841,
            column: 4
          },
          end: {
            line: 844,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 841,
            column: 4
          },
          end: {
            line: 844,
            column: 5
          }
        }, {
          start: {
            line: 841,
            column: 4
          },
          end: {
            line: 844,
            column: 5
          }
        }],
        line: 841
      },
      '84': {
        loc: {
          start: {
            line: 841,
            column: 8
          },
          end: {
            line: 841,
            column: 65
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 841,
            column: 8
          },
          end: {
            line: 841,
            column: 32
          }
        }, {
          start: {
            line: 841,
            column: 36
          },
          end: {
            line: 841,
            column: 65
          }
        }],
        line: 841
      },
      '85': {
        loc: {
          start: {
            line: 847,
            column: 4
          },
          end: {
            line: 853,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 847,
            column: 4
          },
          end: {
            line: 853,
            column: 5
          }
        }, {
          start: {
            line: 847,
            column: 4
          },
          end: {
            line: 853,
            column: 5
          }
        }],
        line: 847
      },
      '86': {
        loc: {
          start: {
            line: 848,
            column: 15
          },
          end: {
            line: 849,
            column: 59
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 848,
            column: 15
          },
          end: {
            line: 848,
            column: 89
          }
        }, {
          start: {
            line: 849,
            column: 18
          },
          end: {
            line: 849,
            column: 59
          }
        }],
        line: 848
      },
      '87': {
        loc: {
          start: {
            line: 877,
            column: 6
          },
          end: {
            line: 879,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 877,
            column: 6
          },
          end: {
            line: 879,
            column: 7
          }
        }, {
          start: {
            line: 877,
            column: 6
          },
          end: {
            line: 879,
            column: 7
          }
        }],
        line: 877
      },
      '88': {
        loc: {
          start: {
            line: 885,
            column: 8
          },
          end: {
            line: 892,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 885,
            column: 8
          },
          end: {
            line: 892,
            column: 9
          }
        }, {
          start: {
            line: 885,
            column: 8
          },
          end: {
            line: 892,
            column: 9
          }
        }],
        line: 885
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0,
      '167': 0,
      '168': 0,
      '169': 0,
      '170': 0,
      '171': 0,
      '172': 0,
      '173': 0,
      '174': 0,
      '175': 0,
      '176': 0,
      '177': 0,
      '178': 0,
      '179': 0,
      '180': 0,
      '181': 0,
      '182': 0,
      '183': 0,
      '184': 0,
      '185': 0,
      '186': 0,
      '187': 0,
      '188': 0,
      '189': 0,
      '190': 0,
      '191': 0,
      '192': 0,
      '193': 0,
      '194': 0,
      '195': 0,
      '196': 0,
      '197': 0,
      '198': 0,
      '199': 0,
      '200': 0,
      '201': 0,
      '202': 0,
      '203': 0,
      '204': 0,
      '205': 0,
      '206': 0,
      '207': 0,
      '208': 0,
      '209': 0,
      '210': 0,
      '211': 0,
      '212': 0,
      '213': 0,
      '214': 0,
      '215': 0,
      '216': 0,
      '217': 0,
      '218': 0,
      '219': 0,
      '220': 0,
      '221': 0,
      '222': 0,
      '223': 0,
      '224': 0,
      '225': 0,
      '226': 0,
      '227': 0,
      '228': 0,
      '229': 0,
      '230': 0,
      '231': 0,
      '232': 0,
      '233': 0,
      '234': 0,
      '235': 0,
      '236': 0,
      '237': 0,
      '238': 0,
      '239': 0,
      '240': 0,
      '241': 0,
      '242': 0,
      '243': 0,
      '244': 0,
      '245': 0,
      '246': 0,
      '247': 0,
      '248': 0,
      '249': 0,
      '250': 0,
      '251': 0,
      '252': 0,
      '253': 0,
      '254': 0,
      '255': 0,
      '256': 0,
      '257': 0,
      '258': 0,
      '259': 0,
      '260': 0,
      '261': 0,
      '262': 0,
      '263': 0,
      '264': 0,
      '265': 0,
      '266': 0,
      '267': 0,
      '268': 0,
      '269': 0,
      '270': 0,
      '271': 0,
      '272': 0,
      '273': 0,
      '274': 0,
      '275': 0,
      '276': 0,
      '277': 0,
      '278': 0,
      '279': 0,
      '280': 0,
      '281': 0,
      '282': 0,
      '283': 0,
      '284': 0,
      '285': 0,
      '286': 0,
      '287': 0,
      '288': 0,
      '289': 0,
      '290': 0,
      '291': 0,
      '292': 0,
      '293': 0,
      '294': 0,
      '295': 0,
      '296': 0,
      '297': 0,
      '298': 0,
      '299': 0,
      '300': 0,
      '301': 0,
      '302': 0,
      '303': 0,
      '304': 0,
      '305': 0,
      '306': 0,
      '307': 0,
      '308': 0,
      '309': 0,
      '310': 0,
      '311': 0,
      '312': 0,
      '313': 0,
      '314': 0,
      '315': 0,
      '316': 0,
      '317': 0,
      '318': 0,
      '319': 0,
      '320': 0,
      '321': 0,
      '322': 0,
      '323': 0,
      '324': 0,
      '325': 0,
      '326': 0,
      '327': 0,
      '328': 0,
      '329': 0,
      '330': 0,
      '331': 0,
      '332': 0,
      '333': 0,
      '334': 0,
      '335': 0,
      '336': 0,
      '337': 0,
      '338': 0,
      '339': 0,
      '340': 0,
      '341': 0,
      '342': 0,
      '343': 0,
      '344': 0,
      '345': 0,
      '346': 0,
      '347': 0,
      '348': 0,
      '349': 0,
      '350': 0,
      '351': 0,
      '352': 0,
      '353': 0,
      '354': 0,
      '355': 0,
      '356': 0,
      '357': 0,
      '358': 0,
      '359': 0,
      '360': 0,
      '361': 0,
      '362': 0,
      '363': 0,
      '364': 0,
      '365': 0,
      '366': 0,
      '367': 0,
      '368': 0,
      '369': 0,
      '370': 0,
      '371': 0,
      '372': 0,
      '373': 0,
      '374': 0,
      '375': 0,
      '376': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0],
      '37': [0, 0],
      '38': [0, 0],
      '39': [0, 0],
      '40': [0, 0],
      '41': [0, 0],
      '42': [0, 0],
      '43': [0, 0],
      '44': [0, 0],
      '45': [0, 0],
      '46': [0, 0],
      '47': [0, 0],
      '48': [0, 0],
      '49': [0, 0],
      '50': [0, 0],
      '51': [0, 0],
      '52': [0, 0],
      '53': [0, 0],
      '54': [0, 0],
      '55': [0, 0],
      '56': [0, 0],
      '57': [0, 0],
      '58': [0, 0],
      '59': [0, 0],
      '60': [0, 0],
      '61': [0, 0],
      '62': [0, 0],
      '63': [0, 0],
      '64': [0, 0],
      '65': [0, 0],
      '66': [0, 0],
      '67': [0, 0],
      '68': [0, 0],
      '69': [0, 0],
      '70': [0, 0],
      '71': [0, 0],
      '72': [0, 0],
      '73': [0, 0],
      '74': [0, 0],
      '75': [0, 0],
      '76': [0, 0],
      '77': [0, 0],
      '78': [0, 0],
      '79': [0, 0],
      '80': [0, 0],
      '81': [0, 0],
      '82': [0, 0],
      '83': [0, 0],
      '84': [0, 0],
      '85': [0, 0],
      '86': [0, 0],
      '87': [0, 0],
      '88': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function milestone_edit($scope, $uibModalInstance, $filter, $CRUDService, $translate) {
  cov_1hqp0yq0kg.f[0]++;

  var PATH = (cov_1hqp0yq0kg.s[0]++, 'MILESTONE');
  cov_1hqp0yq0kg.s[1]++;
  $scope.setValidData = function (item) {
    cov_1hqp0yq0kg.f[1]++;
    cov_1hqp0yq0kg.s[2]++;

    $scope.validateMilestone(item);
    cov_1hqp0yq0kg.s[3]++;
    $scope.closeModal();
  };
  cov_1hqp0yq0kg.s[4]++;
  $scope.closeModal = function () {
    cov_1hqp0yq0kg.f[2]++;
    cov_1hqp0yq0kg.s[5]++;

    $uibModalInstance.dismiss('cancel');
  };
}
cov_1hqp0yq0kg.s[6]++;
angular.module('app').controller('ProgramCtrl', function ($scope, $stateParams, $state, $deltaclearData, $deltaPlanLogique, $log, $deltaGeoData, $deltaProjectStatus, SweetAlert, $rootScope, $deltadate, $translate, $CRUDService, $otherHttpService, $deltahttp, $location, $filter, FileUploader, $http, $uibModal) {
  cov_1hqp0yq0kg.f[3]++;

  var PATH = (cov_1hqp0yq0kg.s[7]++, 'Milestone');
  cov_1hqp0yq0kg.s[8]++;
  $rootScope.personnalPortfolio.getLabelPortfolio();
  cov_1hqp0yq0kg.s[9]++;
  $rootScope.processPageRight('1_1', function () {
    cov_1hqp0yq0kg.f[4]++;
    cov_1hqp0yq0kg.s[10]++;

    $rootScope.global_access_page_denied = false;
    cov_1hqp0yq0kg.s[11]++;
    $rootScope.currentRight.v = true;
  });

  cov_1hqp0yq0kg.s[12]++;
  $scope.selectedProgram = { id: 0 };
  cov_1hqp0yq0kg.s[13]++;
  $scope.selectProgram = function (program) {
    cov_1hqp0yq0kg.f[5]++;
    cov_1hqp0yq0kg.s[14]++;

    $scope.selectedProgram = (cov_1hqp0yq0kg.b[0][0]++, program) || (cov_1hqp0yq0kg.b[0][1]++, { id: 0 });
  };

  cov_1hqp0yq0kg.s[15]++;
  $scope.view = {
    tab: 1,
    activeOnglet: 0
  };
  cov_1hqp0yq0kg.s[16]++;
  $scope.listMonths = $deltadate.getPeriods(Date.newDate('1989-01-01'), Date.newDate('1989-12-31'), 12, false, 1);
  cov_1hqp0yq0kg.s[17]++;
  $scope.listMilestone = [];
  cov_1hqp0yq0kg.s[18]++;
  $scope.listProjects = [];
  cov_1hqp0yq0kg.s[19]++;
  $scope.PATH = 'Projet';

  cov_1hqp0yq0kg.s[20]++;
  $CRUDService.getAll($scope.PATH, { get: 'cross_cutting_state', defined: true }, function (data) {
    cov_1hqp0yq0kg.f[6]++;
    cov_1hqp0yq0kg.s[21]++;

    $scope.editCrossState = data;
  });

  cov_1hqp0yq0kg.s[22]++;
  $scope.contries = [{ id: 1, name: $translate.instant('COUNTRIES.AF') }, { id: 2, name: $translate.instant('COUNTRIES.AX') }, { id: 3, name: $translate.instant('COUNTRIES.AL') }, { id: 4, name: $translate.instant('COUNTRIES.DZ') }, { id: 5, name: $translate.instant('COUNTRIES.AS') }, { id: 6, name: $translate.instant('COUNTRIES.AD') }, { id: 7, name: $translate.instant('COUNTRIES.AO') }, { id: 8, name: $translate.instant('COUNTRIES.AI') }, { id: 9, name: $translate.instant('COUNTRIES.AQ') }, { id: 10, name: $translate.instant('COUNTRIES.AG') }, { id: 11, name: $translate.instant('COUNTRIES.AR') }, { id: 12, name: $translate.instant('COUNTRIES.AM') }, { id: 13, name: $translate.instant('COUNTRIES.AW') }, { id: 14, name: $translate.instant('COUNTRIES.AU') }, { id: 15, name: $translate.instant('COUNTRIES.AT') }, { id: 16, name: $translate.instant('COUNTRIES.AZ') }, { id: 17, name: $translate.instant('COUNTRIES.BS') }, { id: 18, name: $translate.instant('COUNTRIES.BH') }, { id: 19, name: $translate.instant('COUNTRIES.BD') }, { id: 20, name: $translate.instant('COUNTRIES.BB') }, { id: 21, name: $translate.instant('COUNTRIES.BY') }, { id: 22, name: $translate.instant('COUNTRIES.BE') }, { id: 23, name: $translate.instant('COUNTRIES.BZ') }, { id: 24, name: $translate.instant('COUNTRIES.BJ') }, { id: 25, name: $translate.instant('COUNTRIES.BM') }, { id: 26, name: $translate.instant('COUNTRIES.BT') }, { id: 27, name: $translate.instant('COUNTRIES.BO') }, { id: 28, name: $translate.instant('COUNTRIES.BA') }, { id: 29, name: $translate.instant('COUNTRIES.BW') }, { id: 30, name: $translate.instant('COUNTRIES.BV') }, { id: 31, name: $translate.instant('COUNTRIES.BR') }, { id: 32, name: $translate.instant('COUNTRIES.IO') }, { id: 33, name: $translate.instant('COUNTRIES.BN') }, { id: 34, name: $translate.instant('COUNTRIES.BG') }, { id: 35, name: $translate.instant('COUNTRIES.BF') }, { id: 36, name: $translate.instant('COUNTRIES.BI') }, { id: 37, name: $translate.instant('COUNTRIES.KH') }, { id: 38, name: $translate.instant('COUNTRIES.CM') }, { id: 39, name: $translate.instant('COUNTRIES.CA') }, { id: 40, name: $translate.instant('COUNTRIES.CV') }, { id: 41, name: $translate.instant('COUNTRIES.KY') }, { id: 42, name: $translate.instant('COUNTRIES.CF') }, { id: 43, name: $translate.instant('COUNTRIES.TD') }, { id: 44, name: $translate.instant('COUNTRIES.CL') }, { id: 45, name: $translate.instant('COUNTRIES.CN') }, { id: 46, name: $translate.instant('COUNTRIES.CX') }, { id: 47, name: $translate.instant('COUNTRIES.CC') }, { id: 48, name: $translate.instant('COUNTRIES.CO') }, { id: 49, name: $translate.instant('COUNTRIES.KM') }, { id: 50, name: $translate.instant('COUNTRIES.CG') }, { id: 51, name: $translate.instant('COUNTRIES.CD') }, { id: 52, name: $translate.instant('COUNTRIES.CK') }, { id: 53, name: $translate.instant('COUNTRIES.CR') }, { id: 54, name: $translate.instant('COUNTRIES.CI') }, { id: 55, name: $translate.instant('COUNTRIES.HR') }, { id: 56, name: $translate.instant('COUNTRIES.CU') }, { id: 57, name: $translate.instant('COUNTRIES.CY') }, { id: 58, name: $translate.instant('COUNTRIES.CZ') }, { id: 59, name: $translate.instant('COUNTRIES.DK') }, { id: 60, name: $translate.instant('COUNTRIES.DJ') }, { id: 61, name: $translate.instant('COUNTRIES.DM') }, { id: 62, name: $translate.instant('COUNTRIES.DO') }, { id: 63, name: $translate.instant('COUNTRIES.EC') }, { id: 64, name: $translate.instant('COUNTRIES.EG') }, { id: 65, name: $translate.instant('COUNTRIES.SV') }, { id: 66, name: $translate.instant('COUNTRIES.GQ') }, { id: 67, name: $translate.instant('COUNTRIES.ER') }, { id: 68, name: $translate.instant('COUNTRIES.EE') }, { id: 69, name: $translate.instant('COUNTRIES.ET') }, { id: 70, name: $translate.instant('COUNTRIES.FK') }, { id: 71, name: $translate.instant('COUNTRIES.FO') }, { id: 72, name: $translate.instant('COUNTRIES.FJ') }, { id: 73, name: $translate.instant('COUNTRIES.FI') }, { id: 74, name: $translate.instant('COUNTRIES.FR') }, { id: 75, name: $translate.instant('COUNTRIES.GF') }, { id: 76, name: $translate.instant('COUNTRIES.PF') }, { id: 77, name: $translate.instant('COUNTRIES.TF') }, { id: 78, name: $translate.instant('COUNTRIES.GA') }, { id: 79, name: $translate.instant('COUNTRIES.GM') }, { id: 80, name: $translate.instant('COUNTRIES.GE') }, { id: 81, name: $translate.instant('COUNTRIES.DE') }, { id: 82, name: $translate.instant('COUNTRIES.GH') }, { id: 83, name: $translate.instant('COUNTRIES.GI') }, { id: 84, name: $translate.instant('COUNTRIES.GR') }, { id: 85, name: $translate.instant('COUNTRIES.GL') }, { id: 86, name: $translate.instant('COUNTRIES.GD') }, { id: 87, name: $translate.instant('COUNTRIES.GP') }, { id: 88, name: $translate.instant('COUNTRIES.GU') }, { id: 89, name: $translate.instant('COUNTRIES.GT') }, { id: 90, name: $translate.instant('COUNTRIES.GG') }, { id: 91, name: $translate.instant('COUNTRIES.GN') }, { id: 92, name: $translate.instant('COUNTRIES.GW') }, { id: 93, name: $translate.instant('COUNTRIES.GY') }, { id: 94, name: $translate.instant('COUNTRIES.HT') }, { id: 95, name: $translate.instant('COUNTRIES.HM') }, { id: 96, name: $translate.instant('COUNTRIES.VA') }, { id: 97, name: $translate.instant('COUNTRIES.HN') }, { id: 98, name: $translate.instant('COUNTRIES.HK') }, { id: 99, name: $translate.instant('COUNTRIES.HU') }, { id: 100, name: $translate.instant('COUNTRIES.IS') }, { id: 101, name: $translate.instant('COUNTRIES.IN') }, { id: 102, name: $translate.instant('COUNTRIES.ID') }, { id: 103, name: $translate.instant('COUNTRIES.IR') }, { id: 104, name: $translate.instant('COUNTRIES.IQ') }, { id: 105, name: $translate.instant('COUNTRIES.IE') }, { id: 106, name: $translate.instant('COUNTRIES.IM') }, { id: 107, name: $translate.instant('COUNTRIES.IL') }, { id: 108, name: $translate.instant('COUNTRIES.IT') }, { id: 109, name: $translate.instant('COUNTRIES.JM') }, { id: 110, name: $translate.instant('COUNTRIES.JP') }, { id: 111, name: $translate.instant('COUNTRIES.JE') }, { id: 112, name: $translate.instant('COUNTRIES.JO') }, { id: 113, name: $translate.instant('COUNTRIES.KZ') }, { id: 114, name: $translate.instant('COUNTRIES.KE') }, { id: 115, name: $translate.instant('COUNTRIES.KI') }, { id: 116, name: $translate.instant('COUNTRIES.KP') }, { id: 117, name: $translate.instant('COUNTRIES.KR') }, { id: 118, name: $translate.instant('COUNTRIES.KW') }, { id: 119, name: $translate.instant('COUNTRIES.KG') }, { id: 120, name: $translate.instant('COUNTRIES.LA') }, { id: 121, name: $translate.instant('COUNTRIES.LV') }, { id: 122, name: $translate.instant('COUNTRIES.LB') }, { id: 123, name: $translate.instant('COUNTRIES.LS') }, { id: 124, name: $translate.instant('COUNTRIES.LR') }, { id: 125, name: $translate.instant('COUNTRIES.LY') }, { id: 126, name: $translate.instant('COUNTRIES.LI') }, { id: 127, name: $translate.instant('COUNTRIES.LT') }, { id: 128, name: $translate.instant('COUNTRIES.LU') }, { id: 129, name: $translate.instant('COUNTRIES.MO') }, { id: 130, name: $translate.instant('COUNTRIES.MK') }, { id: 131, name: $translate.instant('COUNTRIES.MG') }, { id: 132, name: $translate.instant('COUNTRIES.MW') }, { id: 133, name: $translate.instant('COUNTRIES.MY') }, { id: 134, name: $translate.instant('COUNTRIES.MV') }, { id: 135, name: $translate.instant('COUNTRIES.ML') }, { id: 136, name: $translate.instant('COUNTRIES.MT') }, { id: 137, name: $translate.instant('COUNTRIES.MH') }, { id: 138, name: $translate.instant('COUNTRIES.MQ') }, { id: 139, name: $translate.instant('COUNTRIES.MR') }, { id: 140, name: $translate.instant('COUNTRIES.MU') }, { id: 141, name: $translate.instant('COUNTRIES.YT') }, { id: 142, name: $translate.instant('COUNTRIES.MX') }, { id: 143, name: $translate.instant('COUNTRIES.FM') }, { id: 144, name: $translate.instant('COUNTRIES.MD') }, { id: 145, name: $translate.instant('COUNTRIES.MC') }, { id: 146, name: $translate.instant('COUNTRIES.MN') }, { id: 147, name: $translate.instant('COUNTRIES.MS') }, { id: 148, name: $translate.instant('COUNTRIES.MA') }, { id: 149, name: $translate.instant('COUNTRIES.MZ') }, { id: 150, name: $translate.instant('COUNTRIES.MM') }, { id: 151, name: $translate.instant('COUNTRIES.NA') }, { id: 152, name: $translate.instant('COUNTRIES.NR') }, { id: 153, name: $translate.instant('COUNTRIES.NP') }, { id: 154, name: $translate.instant('COUNTRIES.NL') }, { id: 155, name: $translate.instant('COUNTRIES.AN') }, { id: 156, name: $translate.instant('COUNTRIES.NC') }, { id: 157, name: $translate.instant('COUNTRIES.NZ') }, { id: 158, name: $translate.instant('COUNTRIES.NI') }, { id: 159, name: $translate.instant('COUNTRIES.NE') }, { id: 160, name: $translate.instant('COUNTRIES.NG') }, { id: 161, name: $translate.instant('COUNTRIES.NU') }, { id: 162, name: $translate.instant('COUNTRIES.NF') }, { id: 163, name: $translate.instant('COUNTRIES.MP') }, { id: 164, name: $translate.instant('COUNTRIES.NO') }, { id: 165, name: $translate.instant('COUNTRIES.OM') }, { id: 166, name: $translate.instant('COUNTRIES.PK') }, { id: 167, name: $translate.instant('COUNTRIES.PW') }, { id: 168, name: $translate.instant('COUNTRIES.PS') }, { id: 169, name: $translate.instant('COUNTRIES.PA') }, { id: 170, name: $translate.instant('COUNTRIES.PG') }, { id: 171, name: $translate.instant('COUNTRIES.PY') }, { id: 172, name: $translate.instant('COUNTRIES.PE') }, { id: 173, name: $translate.instant('COUNTRIES.PH') }, { id: 174, name: $translate.instant('COUNTRIES.PN') }, { id: 175, name: $translate.instant('COUNTRIES.PL') }, { id: 176, name: $translate.instant('COUNTRIES.PT') }, { id: 177, name: $translate.instant('COUNTRIES.PR') }, { id: 178, name: $translate.instant('COUNTRIES.QA') }, { id: 179, name: $translate.instant('COUNTRIES.RE') }, { id: 180, name: $translate.instant('COUNTRIES.RO') }, { id: 181, name: $translate.instant('COUNTRIES.RU') }, { id: 182, name: $translate.instant('COUNTRIES.RW') }, { id: 183, name: $translate.instant('COUNTRIES.SH') }, { id: 184, name: $translate.instant('COUNTRIES.KN') }, { id: 185, name: $translate.instant('COUNTRIES.LC') }, { id: 186, name: $translate.instant('COUNTRIES.PM') }, { id: 187, name: $translate.instant('COUNTRIES.VC') }, { id: 188, name: $translate.instant('COUNTRIES.WS') }, { id: 189, name: $translate.instant('COUNTRIES.SM') }, { id: 190, name: $translate.instant('COUNTRIES.ST') }, { id: 191, name: $translate.instant('COUNTRIES.SA') }, { id: 192, name: $translate.instant('COUNTRIES.SN') }, { id: 193, name: $translate.instant('COUNTRIES.CS') }, { id: 194, name: $translate.instant('COUNTRIES.SC') }, { id: 195, name: $translate.instant('COUNTRIES.SL') }, { id: 196, name: $translate.instant('COUNTRIES.SG') }, { id: 197, name: $translate.instant('COUNTRIES.SK') }, { id: 198, name: $translate.instant('COUNTRIES.SI') }, { id: 199, name: $translate.instant('COUNTRIES.SB') }, { id: 200, name: $translate.instant('COUNTRIES.SO') }, { id: 201, name: $translate.instant('COUNTRIES.ZA') }, { id: 202, name: $translate.instant('COUNTRIES.GS') }, { id: 203, name: $translate.instant('COUNTRIES.ES') }, { id: 204, name: $translate.instant('COUNTRIES.LK') }, { id: 205, name: $translate.instant('COUNTRIES.SD') }, { id: 206, name: $translate.instant('COUNTRIES.SR') }, { id: 207, name: $translate.instant('COUNTRIES.SJ') }, { id: 208, name: $translate.instant('COUNTRIES.SZ') }, { id: 209, name: $translate.instant('COUNTRIES.SE') }, { id: 210, name: $translate.instant('COUNTRIES.CH') }, { id: 211, name: $translate.instant('COUNTRIES.SY') }, { id: 212, name: $translate.instant('COUNTRIES.TW') }, { id: 213, name: $translate.instant('COUNTRIES.TJ') }, { id: 214, name: $translate.instant('COUNTRIES.TZ') }, { id: 215, name: $translate.instant('COUNTRIES.TH') }, { id: 216, name: $translate.instant('COUNTRIES.TL') }, { id: 217, name: $translate.instant('COUNTRIES.TG') }, { id: 218, name: $translate.instant('COUNTRIES.TK') }, { id: 219, name: $translate.instant('COUNTRIES.TO') }, { id: 220, name: $translate.instant('COUNTRIES.TT') }, { id: 221, name: $translate.instant('COUNTRIES.TN') }, { id: 222, name: $translate.instant('COUNTRIES.TR') }, { id: 223, name: $translate.instant('COUNTRIES.TM') }, { id: 224, name: $translate.instant('COUNTRIES.TC') }, { id: 225, name: $translate.instant('COUNTRIES.TV') }, { id: 226, name: $translate.instant('COUNTRIES.UG') }, { id: 227, name: $translate.instant('COUNTRIES.UA') }, { id: 228, name: $translate.instant('COUNTRIES.AE') }, { id: 229, name: $translate.instant('COUNTRIES.GB') }, { id: 230, name: $translate.instant('COUNTRIES.US') }, { id: 231, name: $translate.instant('COUNTRIES.UM') }, { id: 232, name: $translate.instant('COUNTRIES.UY') }, { id: 233, name: $translate.instant('COUNTRIES.UZ') }, { id: 234, name: $translate.instant('COUNTRIES.VU') }, { id: 235, name: $translate.instant('COUNTRIES.VE') }, { id: 236, name: $translate.instant('COUNTRIES.VN') }, { id: 237, name: $translate.instant('COUNTRIES.VG') }, { id: 238, name: $translate.instant('COUNTRIES.VI') }, { id: 239, name: $translate.instant('COUNTRIES.WF') }, { id: 240, name: $translate.instant('COUNTRIES.EH') }, { id: 241, name: $translate.instant('COUNTRIES.YE') }, { id: 242, name: $translate.instant('COUNTRIES.ZM') }, { id: 243, name: $translate.instant('COUNTRIES.ZW') }];
  cov_1hqp0yq0kg.s[23]++;
  $scope.changeMonth = function () {
    cov_1hqp0yq0kg.f[7]++;
    cov_1hqp0yq0kg.s[24]++;

    $scope.listFiscalYears = $deltadate.getPeriods($scope.selectedItem.DATE_DEB_PROJET, $scope.selectedItem.DATE_FIN_PROJET, 1, false, $scope.selectedItem.START_MONTH.index);
    cov_1hqp0yq0kg.s[25]++;
    for (var _iterator = $scope.listFiscalYears, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var year = _ref;

      var _ = (cov_1hqp0yq0kg.s[26]++, (cov_1hqp0yq0kg.b[1][0]++, $scope.listPeriodCutting[year.year]) || (cov_1hqp0yq0kg.b[1][1]++, { id: 0, period: '0' }));
      cov_1hqp0yq0kg.s[27]++;
      year.id = _.id;
      cov_1hqp0yq0kg.s[28]++;
      year.period = $filter('filter')($scope.listPeriodicity, { id: _.period }, true)[0];
    }
  };
  cov_1hqp0yq0kg.s[29]++;
  $scope.listPeriodicity = [{
    label: $translate.instant('COMMON.YEAR'),
    id: '1'
  }, {
    label: $translate.instant('COMMON.SEM'),
    id: '2'
  }, {
    label: $translate.instant('COMMON.TRIM'),
    id: '4'
  }, {
    label: $translate.instant('COMMON.MOIS'),
    id: '12'
  }, {
    label: '',
    id: '0'
  }];

  cov_1hqp0yq0kg.s[30]++;
  $scope.contries.sort(function (a, b) {
    cov_1hqp0yq0kg.f[8]++;
    cov_1hqp0yq0kg.s[31]++;

    if (a.name > b.name) {
      cov_1hqp0yq0kg.b[2][0]++;
      cov_1hqp0yq0kg.s[32]++;

      return 1;
    } else {
      cov_1hqp0yq0kg.b[2][1]++;
    }
    cov_1hqp0yq0kg.s[33]++;
    if (a.name < b.name) {
      cov_1hqp0yq0kg.b[3][0]++;
      cov_1hqp0yq0kg.s[34]++;

      return -1;
    } else {
      cov_1hqp0yq0kg.b[3][1]++;
    }
    cov_1hqp0yq0kg.s[35]++;
    return 0;
  });

  cov_1hqp0yq0kg.s[36]++;
  $scope.doughnutOptions = {
    segmentShowStroke: true,
    segmentStrokeColor: '#fff',
    segmentStrokeWidth: 2,
    percentageInnerCutout: 45,
    animationSteps: 100,
    animationEasing: 'easeOutBounce',
    animateRotate: true,
    animateScale: false
  };
  cov_1hqp0yq0kg.s[37]++;
  $scope.error = {};
  cov_1hqp0yq0kg.s[38]++;
  $scope.listPrograms = [];
  cov_1hqp0yq0kg.s[39]++;
  $scope.view.activeOnglet = 0;
  cov_1hqp0yq0kg.s[40]++;
  $scope.statutsList = $deltaProjectStatus.getList();

  cov_1hqp0yq0kg.s[41]++;
  $scope.getAll = function () {
    cov_1hqp0yq0kg.f[9]++;

    var toda = (cov_1hqp0yq0kg.s[42]++, Date.newDate());

    var idPortfolio = (cov_1hqp0yq0kg.s[43]++, localStorage.getItem('PORTFOLIO_ID_KEY'));
    cov_1hqp0yq0kg.s[44]++;
    $scope.isloading = true;
    cov_1hqp0yq0kg.s[45]++;
    $CRUDService.getAll($scope.PATH, { get: 'portfolio-single', id: idPortfolio }, function (data_) {
      cov_1hqp0yq0kg.f[10]++;

      var data = (cov_1hqp0yq0kg.s[46]++, data_.length == 0 ? (cov_1hqp0yq0kg.b[4][0]++, null) : (cov_1hqp0yq0kg.b[4][1]++, data_[0]));
      var date = (cov_1hqp0yq0kg.s[47]++, Date.newDate());
      cov_1hqp0yq0kg.s[48]++;
      date.setMonth(date.getMonth() + 120);
      cov_1hqp0yq0kg.s[49]++;
      if (data == null) {
        cov_1hqp0yq0kg.b[5][0]++;
        cov_1hqp0yq0kg.s[50]++;

        data = {
          ID_PROGRAM: 0,
          PORTFOLIO: 1,
          ADR_PROJET: '',
          AG_EXE_PROJET: '',
          CODE_ESPACE: '',
          CODE_PRJ: '__________',
          DATE_DEB_PROJET: Date.newDate(),
          DATE_FIN_PROJET: date,
          DESCRIPTION_PROJET: '',
          Format_cout: '',
          ID_LOG_FRAME: 0,
          LIBELLE_PROJET: '',
          PAYS_PROJET: $scope.contries[0].id,
          LINK_PG: false,
          FAX_PROJET: '',
          EMAIL_PROJET: '',
          TEL_PROJET: '',
          id: 0,
          OBJECTIF: '',
          INDICATOR_FIELD_1: '',
          INDICATOR_FIELD_2: '',
          CIBLE: '',
          ZONE: '',
          STATUT: 0,
          STATUS: $scope.statutsList[1].id,
          DATE_MI_PRO: Date.newDate(),
          FINAN: '',
          COUT: 0,
          IDS_AGENCY: [],
          STATUT_BUDGET: false,
          ID_AGENCY: 0,
          CROSS_CUTTING_KPIS: false,
          PORTFOLIO_CROSS_CUTTING_KPIS: true,
          CUSTOM_FIELD: false,
          MISSIONS: false,
          RISK: false,
          PROBLEM: false,
          ACTIVE_SMS: false,
          LINK: {
            U: 0,
            SF: 0,
            PG: 0,
            PL: 0,
            F: 0,
            TA: 0,
            TI: 0,
            TR: 0,
            FR: 0
          },
          PERIODIC_FOLLOW: $scope.listPeriodicity[0].id,
          ME_METHOD: $scope.listOptionSEMethods[0].id,
          START_MONTH: $scope.listMonths[0].id,
          GLOBAL_PLAN: 0,
          ACTIVITY_WEIGHT: 0,
          ACTIVITY_WEIGHT_AN: 0,
          DISPLAY_DATA: 0
        };
      } else {
        cov_1hqp0yq0kg.b[5][1]++;
        cov_1hqp0yq0kg.s[51]++;

        data.img = $deltahttp.getProjectRepository(data.id, Date.newDate());
        cov_1hqp0yq0kg.s[52]++;
        data.DATE_DEB_PROJET = Date.newDate(data.DATE_DEB_PROJET);
        cov_1hqp0yq0kg.s[53]++;
        data.COUT = eval(data.COUT);
        cov_1hqp0yq0kg.s[54]++;
        data.CROSS_CUTTING_KPIS = data.CROSS_CUTTING_KPIS == 1;
        cov_1hqp0yq0kg.s[55]++;
        data.PORTFOLIO_CROSS_CUTTING_KPIS = data.PORTFOLIO_CROSS_CUTTING_KPIS == 1;
        cov_1hqp0yq0kg.s[56]++;
        data.CUSTOM_FIELD = data.CUSTOM_FIELD == 1;
        cov_1hqp0yq0kg.s[57]++;
        data.MISSIONS = data.MISSIONS == 1;
        cov_1hqp0yq0kg.s[58]++;
        data.RISK = data.RISK == 1;
        cov_1hqp0yq0kg.s[59]++;
        data.PROBLEM = data.PROBLEM == 1;
        cov_1hqp0yq0kg.s[60]++;
        data.ACTIVE_SMS = data.ACTIVE_SMS == 1;

        cov_1hqp0yq0kg.s[61]++;
        data.STATUT_BUDGET = parseInt(data.STATUT_BUDGET, 10) === 1;
        cov_1hqp0yq0kg.s[62]++;
        data.DATE_FIN_PROJET = Date.newDate(data.DATE_FIN_PROJET);
        cov_1hqp0yq0kg.s[63]++;
        data.DATE_MI_PRO = Date.newDate((cov_1hqp0yq0kg.b[6][0]++, data.DATE_MI_PRO) || (cov_1hqp0yq0kg.b[6][1]++, undefined));

        var diff = (cov_1hqp0yq0kg.s[64]++, data.DATE_FIN_PROJET - data.DATE_DEB_PROJET);
        cov_1hqp0yq0kg.s[65]++;
        data.progress = 0;
        cov_1hqp0yq0kg.s[66]++;
        if (diff != 0) {
          cov_1hqp0yq0kg.b[7][0]++;
          cov_1hqp0yq0kg.s[67]++;

          data.progress = Math.min((toda - data.DATE_DEB_PROJET) / diff * 100, 100);
        } else {
          cov_1hqp0yq0kg.b[7][1]++;
        }
        cov_1hqp0yq0kg.s[68]++;
        if (data.progress < 0) {
          cov_1hqp0yq0kg.b[8][0]++;
          cov_1hqp0yq0kg.s[69]++;

          data.progress = 0;
        } else {
          cov_1hqp0yq0kg.b[8][1]++;
        }
        cov_1hqp0yq0kg.s[70]++;
        data.PAYS_PROJET = parseInt(data.PAYS_PROJET, 10);
        cov_1hqp0yq0kg.s[71]++;
        data.PAYS = $filter('filter')($scope.contries, { id: data.PAYS_PROJET }, true)[0];

        cov_1hqp0yq0kg.s[72]++;
        data.progress = {
          data: [{
            value: data.progress,
            highlight: '#1ab394',
            label: '',
            color: '#1ab394'

          }, {
            value: 100 - data.progress,
            highlight: '#d7d7d7',
            label: '',
            color: '#d7d7d7'
          }]
        };
      }
      cov_1hqp0yq0kg.s[73]++;
      $scope.edit(data);
    });
  };

  cov_1hqp0yq0kg.s[74]++;
  $scope.selectedItem = {};
  cov_1hqp0yq0kg.s[75]++;
  $scope.cancel = function () {
    cov_1hqp0yq0kg.f[11]++;
    cov_1hqp0yq0kg.s[76]++;

    $rootScope.goToPrevious();
  };
  cov_1hqp0yq0kg.s[77]++;
  $scope.validate = function () {
    cov_1hqp0yq0kg.f[12]++;

    var validateItem = (cov_1hqp0yq0kg.s[78]++, angular.copy($scope.selectedItem));
    cov_1hqp0yq0kg.s[79]++;
    validateItem.DATE_DEB_PROJET = $deltadate.format($scope.selectedItem.DATE_DEB_PROJET, 'dd/mm/yyyy');
    cov_1hqp0yq0kg.s[80]++;
    validateItem.DATE_FIN_PROJET = $deltadate.format($scope.selectedItem.DATE_FIN_PROJET, 'dd/mm/yyyy');
    cov_1hqp0yq0kg.s[81]++;
    validateItem.DATE_MI_PRO = $deltadate.format($scope.selectedItem.DATE_MI_PRO, 'yyyy-mm-dd');
    cov_1hqp0yq0kg.s[82]++;
    validateItem.PAYS_PROJET = $scope.selectedItem.PAYS_PROJET.id;
    cov_1hqp0yq0kg.s[83]++;
    validateItem.ID_AGENCY = 0;cov_1hqp0yq0kg.s[84]++;

    validateItem.IDS_AGENCY = $scope.selectedItem.IDS_AGENCY.map(function (value) {
      cov_1hqp0yq0kg.f[13]++;
      cov_1hqp0yq0kg.s[85]++;
      return value.id;
    });
    cov_1hqp0yq0kg.s[86]++;
    validateItem.STATUT_BUDGET = (cov_1hqp0yq0kg.b[10][0]++, $scope.selectedItem.DISPLAY_DATA) && (cov_1hqp0yq0kg.b[10][1]++, $scope.selectedItem.STATUT_BUDGET) ? (cov_1hqp0yq0kg.b[9][0]++, 1) : (cov_1hqp0yq0kg.b[9][1]++, 0);
    cov_1hqp0yq0kg.s[87]++;
    validateItem.STATUS = $scope.selectedItem.STATUS.id;
    cov_1hqp0yq0kg.s[88]++;
    validateItem.GLOBAL_PLAN = $scope.selectedItem.GLOBAL_PLAN ? (cov_1hqp0yq0kg.b[11][0]++, 1) : (cov_1hqp0yq0kg.b[11][1]++, 0);
    cov_1hqp0yq0kg.s[89]++;
    validateItem.ACTIVITY_WEIGHT = $scope.selectedItem.ACTIVITY_WEIGHT ? (cov_1hqp0yq0kg.b[12][0]++, 1) : (cov_1hqp0yq0kg.b[12][1]++, 0);
    cov_1hqp0yq0kg.s[90]++;
    validateItem.ACTIVITY_WEIGHT_AN = (cov_1hqp0yq0kg.b[14][0]++, $scope.selectedItem.ACTIVITY_WEIGHT) && (cov_1hqp0yq0kg.b[14][1]++, $scope.selectedItem.ACTIVITY_WEIGHT_AN) ? (cov_1hqp0yq0kg.b[13][0]++, 1) : (cov_1hqp0yq0kg.b[13][1]++, 0);
    cov_1hqp0yq0kg.s[91]++;
    validateItem.DISPLAY_DATA = $scope.selectedItem.DISPLAY_DATA ? (cov_1hqp0yq0kg.b[15][0]++, 1) : (cov_1hqp0yq0kg.b[15][1]++, 0);

    cov_1hqp0yq0kg.s[92]++;
    validateItem.CROSS_CUTTING_KPIS = $scope.selectedItem.CROSS_CUTTING_KPIS ? (cov_1hqp0yq0kg.b[16][0]++, 1) : (cov_1hqp0yq0kg.b[16][1]++, 0);
    cov_1hqp0yq0kg.s[93]++;
    validateItem.PORTFOLIO_CROSS_CUTTING_KPIS = $scope.selectedItem.PORTFOLIO_CROSS_CUTTING_KPIS ? (cov_1hqp0yq0kg.b[17][0]++, 1) : (cov_1hqp0yq0kg.b[17][1]++, 0);
    cov_1hqp0yq0kg.s[94]++;
    validateItem.CUSTOM_FIELD = $scope.selectedItem.CUSTOM_FIELD ? (cov_1hqp0yq0kg.b[18][0]++, 1) : (cov_1hqp0yq0kg.b[18][1]++, 0);
    cov_1hqp0yq0kg.s[95]++;
    validateItem.MISSIONS = $scope.selectedItem.MISSIONS ? (cov_1hqp0yq0kg.b[19][0]++, 1) : (cov_1hqp0yq0kg.b[19][1]++, 0);
    cov_1hqp0yq0kg.s[96]++;
    validateItem.RISK = $scope.selectedItem.RISK ? (cov_1hqp0yq0kg.b[20][0]++, 1) : (cov_1hqp0yq0kg.b[20][1]++, 0);
    cov_1hqp0yq0kg.s[97]++;
    validateItem.PROBLEM = $scope.selectedItem.PROBLEM ? (cov_1hqp0yq0kg.b[21][0]++, 1) : (cov_1hqp0yq0kg.b[21][1]++, 0);
    cov_1hqp0yq0kg.s[98]++;
    validateItem.ACTIVE_SMS = $scope.selectedItem.ACTIVE_SMS ? (cov_1hqp0yq0kg.b[22][0]++, 1) : (cov_1hqp0yq0kg.b[22][1]++, 0);
    cov_1hqp0yq0kg.s[99]++;
    validateItem.ACTIVE_SUP = $scope.selectedItem.ACTIVE_SUP ? (cov_1hqp0yq0kg.b[23][0]++, 1) : (cov_1hqp0yq0kg.b[23][1]++, 0);

    cov_1hqp0yq0kg.s[100]++;
    validateItem.LINK_PG = $scope.selectedItem.LINK_PG ? (cov_1hqp0yq0kg.b[24][0]++, 1) : (cov_1hqp0yq0kg.b[24][1]++, 0);
    cov_1hqp0yq0kg.s[101]++;
    validateItem.PERIODIC_FOLLOW = 1;cov_1hqp0yq0kg.s[102]++;

    validateItem.ME_METHOD = 2;cov_1hqp0yq0kg.s[103]++;

    validateItem.ID_LOG_FRAME = $scope.selectedItem.ID_LOG_FRAME.id;cov_1hqp0yq0kg.s[104]++;

    validateItem.START_MONTH = $scope.selectedItem.START_MONTH.index;

    cov_1hqp0yq0kg.s[105]++;
    validateItem.LINK = {
      U: $scope.selectedItem.LINK.U ? (cov_1hqp0yq0kg.b[25][0]++, '1') : (cov_1hqp0yq0kg.b[25][1]++, '0'),
      SF: $scope.selectedItem.LINK.SF ? (cov_1hqp0yq0kg.b[26][0]++, '1') : (cov_1hqp0yq0kg.b[26][1]++, '0'),
      PG: $scope.selectedItem.LINK.PG ? (cov_1hqp0yq0kg.b[27][0]++, '1') : (cov_1hqp0yq0kg.b[27][1]++, '0'),
      PL: $scope.selectedItem.LINK.PL ? (cov_1hqp0yq0kg.b[28][0]++, '1') : (cov_1hqp0yq0kg.b[28][1]++, '0'),
      F: $scope.selectedItem.LINK.F ? (cov_1hqp0yq0kg.b[29][0]++, '1') : (cov_1hqp0yq0kg.b[29][1]++, '0'),
      TA: $scope.selectedItem.LINK.TA ? (cov_1hqp0yq0kg.b[30][0]++, '1') : (cov_1hqp0yq0kg.b[30][1]++, '0'),
      TI: $scope.selectedItem.LINK.TI ? (cov_1hqp0yq0kg.b[31][0]++, '1') : (cov_1hqp0yq0kg.b[31][1]++, '0'),
      TR: $scope.selectedItem.LINK.TR ? (cov_1hqp0yq0kg.b[32][0]++, '1') : (cov_1hqp0yq0kg.b[32][1]++, '0'),
      FR: $scope.selectedItem.LINK.FR ? (cov_1hqp0yq0kg.b[33][0]++, '1') : (cov_1hqp0yq0kg.b[33][1]++, '0')
    };
    cov_1hqp0yq0kg.s[106]++;
    $scope.error = {
      id: 0,
      label: null
    };
    cov_1hqp0yq0kg.s[107]++;

    for (var i = 0; i < $scope.listProjects.length; i++) {
      var item = (cov_1hqp0yq0kg.s[108]++, $scope.listProjects[i]);
      cov_1hqp0yq0kg.s[109]++;
      if ($scope.listProjects[i].id == item.id) {
        cov_1hqp0yq0kg.b[34][0]++;
        cov_1hqp0yq0kg.s[110]++;

        if ((cov_1hqp0yq0kg.b[36][0]++, item.id != validateItem.id) && (cov_1hqp0yq0kg.b[36][1]++, validateItem.CODE_PRJ == item.CODE_PRJ)) {
          cov_1hqp0yq0kg.b[35][0]++;
          cov_1hqp0yq0kg.s[111]++;

          $scope.error = {
            id: 1,
            label: 'PROJECT.ERROR.DBL'
          };
          cov_1hqp0yq0kg.s[112]++;
          $scope.edit.tab = 1;
          cov_1hqp0yq0kg.s[113]++;
          return;
        } else {
          cov_1hqp0yq0kg.b[35][1]++;
        }
      } else {
        cov_1hqp0yq0kg.b[34][1]++;
      }
    }
    cov_1hqp0yq0kg.s[114]++;
    if ($scope.selectedItem.DATE_DEB_PROJET > $scope.selectedItem.DATE_FIN_PROJET) {
      cov_1hqp0yq0kg.b[37][0]++;
      cov_1hqp0yq0kg.s[115]++;

      $scope.error = {
        id: 2,
        label: 'PROJECT.ERROR.DATE'
      };
      cov_1hqp0yq0kg.s[116]++;
      $scope.edit.tab = 1;
      cov_1hqp0yq0kg.s[117]++;
      return;
    } else {
      cov_1hqp0yq0kg.b[37][1]++;
    }
    cov_1hqp0yq0kg.s[118]++;
    if (validateItem.Format_cout.length > 5) {
      cov_1hqp0yq0kg.b[38][0]++;
      cov_1hqp0yq0kg.s[119]++;

      $scope.error = {
        id: 3,
        label: 'PROJECT.ERROR.CURRENCY'
      };
      cov_1hqp0yq0kg.s[120]++;
      $scope.edit.tab = 1;
      cov_1hqp0yq0kg.s[121]++;
      return;
    } else {
      cov_1hqp0yq0kg.b[38][1]++;
    }

    cov_1hqp0yq0kg.s[122]++;
    validateItem.img = undefined;
    cov_1hqp0yq0kg.s[123]++;
    validateItem.progress = undefined;

    cov_1hqp0yq0kg.s[124]++;
    if ((cov_1hqp0yq0kg.b[40][0]++, $scope.LAST_START_MONTH != validateItem.START_MONTH) && (cov_1hqp0yq0kg.b[40][1]++, validateItem.id != 0)) {
      cov_1hqp0yq0kg.b[39][0]++;
      cov_1hqp0yq0kg.s[125]++;

      SweetAlert.swal({
        title: '',
        text: $translate.instant('PROJECT.ERROR.SAVING'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55', cancelButtonColor: '#c8c8c8',
        confirmButtonText: $translate.instant('COMMON.CANCEL'),
        cancelButtonText: $translate.instant('COMMON.CONTINUE'),
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isconfirm) {
        cov_1hqp0yq0kg.f[14]++;
        cov_1hqp0yq0kg.s[126]++;

        if (isconfirm) {
          cov_1hqp0yq0kg.b[41][0]++;
          cov_1hqp0yq0kg.s[127]++;

          return;
        } else {
          cov_1hqp0yq0kg.b[41][1]++;
        }
        cov_1hqp0yq0kg.s[128]++;
        $scope.__saveProject(validateItem);
      });
    } else {
      cov_1hqp0yq0kg.b[39][1]++;
      cov_1hqp0yq0kg.s[129]++;

      $scope.__saveProject(validateItem);
    }
    cov_1hqp0yq0kg.s[130]++;
    $state.go('index.projects');
  };

  cov_1hqp0yq0kg.s[131]++;
  $scope.changeActivateSms = function () {
    cov_1hqp0yq0kg.f[15]++;
    cov_1hqp0yq0kg.s[132]++;

    if ($scope.selectedItem.ACTIVE_SMS) {
      cov_1hqp0yq0kg.b[42][0]++;
      cov_1hqp0yq0kg.s[133]++;

      SweetAlert.swal({
        title: $translate.instant('PROJECT.ACTIVE_SMS_WARNING'),

        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#c8c8c8',
        cancelButtonText: $translate.instant('COMMON.YES'),
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        cov_1hqp0yq0kg.f[16]++;
        cov_1hqp0yq0kg.s[134]++;

        if (isConfirm) {
          cov_1hqp0yq0kg.b[43][0]++;
          cov_1hqp0yq0kg.s[135]++;

          return;
        } else {
          cov_1hqp0yq0kg.b[43][1]++;
        }
      });
    } else {
      cov_1hqp0yq0kg.b[42][1]++;
    }
  };

  cov_1hqp0yq0kg.s[136]++;
  $CRUDService.getAll($scope.PATH, { get: 'devises' }, function (_data2) {
    cov_1hqp0yq0kg.f[17]++;
    cov_1hqp0yq0kg.s[137]++;

    $scope.autoCompleteGroupOptions = {
      minimumChars: 0,
      containerCssClass: 'white-bg',
      selectedCssClass: 'selected-item-auto-complete',
      noMatchTemplateEnabled: false,
      activateOnFocus: true,
      data: function data(searchText) {
        cov_1hqp0yq0kg.s[138]++;

        return _data2;
      }
    };
  });
  cov_1hqp0yq0kg.s[139]++;
  $scope.__saveProject = function (validateItem) {
    cov_1hqp0yq0kg.f[18]++;

    var valueP = (cov_1hqp0yq0kg.s[140]++, $filter('json')(validateItem, 3));
    cov_1hqp0yq0kg.s[141]++;
    $scope.isloading = true;
    cov_1hqp0yq0kg.s[142]++;
    $CRUDService.save($scope.PATH, { action: 'miseAJourAdmin', valeur: validateItem }, function (result) {
      cov_1hqp0yq0kg.f[19]++;

      var data = (cov_1hqp0yq0kg.s[143]++, parseInt(result, 10));
      cov_1hqp0yq0kg.s[144]++;
      if (data > 0) {
        cov_1hqp0yq0kg.b[44][0]++;
        cov_1hqp0yq0kg.s[145]++;

        for (var _iterator2 = $scope.addingSource, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
          var _ref2;

          if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref2 = _iterator2[_i2++];
          } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref2 = _i2.value;
          }

          var source = _ref2;
          cov_1hqp0yq0kg.s[146]++;

          $CRUDService.save('Financement', { action: 'MiseAJourProjet', valeur: $filter('json')(source), id: data });
        }
        cov_1hqp0yq0kg.s[147]++;
        for (var _iterator3 = (cov_1hqp0yq0kg.b[45][0]++, $scope.deletedMilestone) || (cov_1hqp0yq0kg.b[45][1]++, []), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
          var _ref3;

          if (_isArray3) {
            if (_i3 >= _iterator3.length) break;
            _ref3 = _iterator3[_i3++];
          } else {
            _i3 = _iterator3.next();
            if (_i3.done) break;
            _ref3 = _i3.value;
          }

          var id = _ref3;
          cov_1hqp0yq0kg.s[148]++;

          $CRUDService.delet(PATH, { action: 'supp', id: id });
        }
        cov_1hqp0yq0kg.s[149]++;
        for (var _iterator4 = $scope.listMilestone, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
          var _ref4;

          if (_isArray4) {
            if (_i4 >= _iterator4.length) break;
            _ref4 = _iterator4[_i4++];
          } else {
            _i4 = _iterator4.next();
            if (_i4.done) break;
            _ref4 = _i4.value;
          }

          var milestone = _ref4;
          cov_1hqp0yq0kg.s[150]++;

          milestone.ID_PROJET = data;
          cov_1hqp0yq0kg.s[151]++;
          milestone.REALIZE = milestone.REALIZE ? (cov_1hqp0yq0kg.b[46][0]++, 1) : (cov_1hqp0yq0kg.b[46][1]++, 0);
          cov_1hqp0yq0kg.s[152]++;
          $CRUDService.save(PATH, { action: 'miseAJour', valeur: $filter('json')(milestone) });
        }
        cov_1hqp0yq0kg.s[153]++;
        for (var _iterator5 = $scope.listFiscalYears, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
          var _ref5;

          if (_isArray5) {
            if (_i5 >= _iterator5.length) break;
            _ref5 = _iterator5[_i5++];
          } else {
            _i5 = _iterator5.next();
            if (_i5.done) break;
            _ref5 = _i5.value;
          }

          var per = _ref5;
          cov_1hqp0yq0kg.s[154]++;

          $CRUDService.save('Periode', { action: 'save_periode_project', id: data, valeur: $filter('json')({
              ANNEE_PERIOD: per.year,
              DECOUPAGE_PERIOD: per.period.id,
              id: per.id
            }) }, function (_data) {
            cov_1hqp0yq0kg.f[20]++;
            cov_1hqp0yq0kg.s[155]++;

            if (_data == -1) {
              cov_1hqp0yq0kg.b[47][0]++;
              cov_1hqp0yq0kg.s[156]++;

              return;
            } else {
              cov_1hqp0yq0kg.b[47][1]++;
            }
          });
        }
      } else {
        cov_1hqp0yq0kg.b[44][1]++;
      }

      cov_1hqp0yq0kg.s[157]++;

      if ((cov_1hqp0yq0kg.b[49][0]++, validateItem.id > 0) && (cov_1hqp0yq0kg.b[49][1]++, validateItem.ACTIVE_SUP == 0)) {
        cov_1hqp0yq0kg.b[48][0]++;
        cov_1hqp0yq0kg.s[158]++;

        $CRUDService.getAll($scope.PATH, { get: 'remove_all_deleted', id: validateItem.id, ACTIVE_SUP: validateItem.ACTIVE_SUP }, function (data_) {
          cov_1hqp0yq0kg.f[21]++;
        });
      } else {
        cov_1hqp0yq0kg.b[48][1]++;
      }

      cov_1hqp0yq0kg.s[159]++;
      $state.go('index.projects');
    });
  };

  cov_1hqp0yq0kg.s[160]++;
  $scope.edit = function (item) {
    cov_1hqp0yq0kg.f[22]++;
    cov_1hqp0yq0kg.s[161]++;

    $scope.isloading = false;
    cov_1hqp0yq0kg.s[162]++;
    $scope.LAST_START_MONTH = item.START_MONTH;
    cov_1hqp0yq0kg.s[163]++;
    $scope.addingSource = [];
    cov_1hqp0yq0kg.s[164]++;
    $scope.edit.tab = 1;
    cov_1hqp0yq0kg.s[165]++;
    $scope.edit.tabPeriod = 1;
    cov_1hqp0yq0kg.s[166]++;
    $scope.error_code = false;
    cov_1hqp0yq0kg.s[167]++;
    $scope.isadd = true;
    cov_1hqp0yq0kg.s[168]++;
    $scope.selectedItem = angular.copy(item);
    cov_1hqp0yq0kg.s[169]++;
    $scope.selectedItem.PERIODIC_FOLLOW = $filter('filter')($scope.listPeriodicity, { id: (cov_1hqp0yq0kg.b[50][0]++, item.PERIODIC_FOLLOW) || (cov_1hqp0yq0kg.b[50][1]++, '1') }, true)[0];
    cov_1hqp0yq0kg.s[170]++;
    $scope.selectedItem.STATUS = $filter('filter')($scope.statutsList, { id: (cov_1hqp0yq0kg.b[51][0]++, parseInt(item.STATUS, 10)) || (cov_1hqp0yq0kg.b[51][1]++, 1) }, true)[0];

    cov_1hqp0yq0kg.s[171]++;
    if ((cov_1hqp0yq0kg.b[53][0]++, $scope.listOptionSEMethods) && (cov_1hqp0yq0kg.b[53][1]++, $scope.listOptionSEMethods.length > 0)) {
      cov_1hqp0yq0kg.b[52][0]++;
      cov_1hqp0yq0kg.s[172]++;

      $scope.selectedItem.ID_LOG_FRAME = $scope.listOptionSEMethods.find(function (value) {
        cov_1hqp0yq0kg.f[23]++;
        cov_1hqp0yq0kg.s[173]++;

        return value.id == item.ID_LOG_FRAME;
      });

      cov_1hqp0yq0kg.s[174]++;
      if (!$scope.selectedItem.ID_LOG_FRAME) {
        cov_1hqp0yq0kg.b[54][0]++;
        cov_1hqp0yq0kg.s[175]++;

        $scope.selectedItem.ID_LOG_FRAME = $scope.listOptionSEMethods[$scope.listOptionSEMethods.length - 1];
      } else {
        cov_1hqp0yq0kg.b[54][1]++;
      }
    } else {
      cov_1hqp0yq0kg.b[52][1]++;
    }

    cov_1hqp0yq0kg.s[176]++;
    $scope.selectedItem.ACTIVE_SUP = item.ACTIVE_SUP == 1;
    cov_1hqp0yq0kg.s[177]++;
    $scope.selectedItem.CHAMP_LIBRE = item.CHAMP_LIBRE == "1";
    cov_1hqp0yq0kg.s[178]++;
    $scope.selectedItem.OPTIONS_FIXES = item.OPTIONS_FIXES == "1";

    cov_1hqp0yq0kg.s[179]++;

    $scope.selectedItem.START_MONTH = $filter('filter')($scope.listMonths, { index: parseInt((cov_1hqp0yq0kg.b[55][0]++, item.START_MONTH) || (cov_1hqp0yq0kg.b[55][1]++, 1), 10) }, true)[0];
    cov_1hqp0yq0kg.s[180]++;
    $scope.selectedItem.GLOBAL_PLAN = item.GLOBAL_PLAN == 1;
    cov_1hqp0yq0kg.s[181]++;
    $scope.selectedItem.ACTIVITY_WEIGHT = item.ACTIVITY_WEIGHT == 1;
    cov_1hqp0yq0kg.s[182]++;
    $scope.selectedItem.ACTIVITY_WEIGHT_AN = item.ACTIVITY_WEIGHT_AN == 1;
    cov_1hqp0yq0kg.s[183]++;
    $scope.selectedItem.DISPLAY_DATA = item.DISPLAY_DATA == 1;
    cov_1hqp0yq0kg.s[184]++;
    $scope.selectedItem.LINK_PG = item.LINK_PG == 1;
    cov_1hqp0yq0kg.s[185]++;
    $scope.selectedItem.PAYS_PROJET = $filter('filter')($scope.contries, { id: item.PAYS_PROJET }, true)[0];cov_1hqp0yq0kg.s[186]++;

    $scope.selectedItem.LINK = {
      U: $scope.selectedItem.LINK.U != 0,
      SF: $scope.selectedItem.LINK.SF != 0,
      PG: $scope.selectedItem.LINK.PG != 0,
      PL: $scope.selectedItem.LINK.PL != 0,
      F: $scope.selectedItem.LINK.F != 0,
      TA: $scope.selectedItem.LINK.TA != 0,
      TI: $scope.selectedItem.LINK.TI != 0,
      TR: $scope.selectedItem.LINK.TR != 0,
      FR: $scope.selectedItem.LINK.FR != 0
    };
    cov_1hqp0yq0kg.s[187]++;
    $scope.selectedItem.IDS_AGENCY = [];
    cov_1hqp0yq0kg.s[188]++;
    $scope.initialImg = $deltahttp.getProjectRepository($scope.selectedItem.id);
    cov_1hqp0yq0kg.s[189]++;
    if (item.id) {
      cov_1hqp0yq0kg.b[56][0]++;
      cov_1hqp0yq0kg.s[190]++;

      $CRUDService.getAll('NiveauCl', { get: 'count', id: item.id }, function (data) {
        cov_1hqp0yq0kg.f[24]++;
        cov_1hqp0yq0kg.s[191]++;

        $scope.blockDelete = parseInt(data, 10) > 0;
      });
    } else {
      cov_1hqp0yq0kg.b[56][1]++;
    }
    cov_1hqp0yq0kg.s[192]++;
    $scope.listPeriodCutting = {};
    cov_1hqp0yq0kg.s[193]++;
    $CRUDService.getAll('Periode', { get: 'all_projet', id: $scope.selectedItem.id }, function (data) {
      cov_1hqp0yq0kg.f[25]++;
      cov_1hqp0yq0kg.s[194]++;

      for (var _iterator6 = data, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
        var _ref6;

        if (_isArray6) {
          if (_i6 >= _iterator6.length) break;
          _ref6 = _iterator6[_i6++];
        } else {
          _i6 = _iterator6.next();
          if (_i6.done) break;
          _ref6 = _i6.value;
        }

        var it = _ref6;
        cov_1hqp0yq0kg.s[195]++;

        $scope.listPeriodCutting[it.ANNEE_PERIOD] = {
          period: it.DECOUPAGE_PERIOD,
          id: it.id
        };
      }
      cov_1hqp0yq0kg.s[196]++;

      $scope.changeMonth();
    });
    cov_1hqp0yq0kg.s[197]++;
    $scope.locks = {
      plan_global: false,
      periods: []
    };
    cov_1hqp0yq0kg.s[198]++;
    $CRUDService.getAll($scope.PATH, { get: 'can_update', id: $scope.selectedItem.id }, function (data) {
      cov_1hqp0yq0kg.f[26]++;
      cov_1hqp0yq0kg.s[199]++;

      $scope.locks = data;
    });

    cov_1hqp0yq0kg.s[200]++;
    $scope.isedit = $scope.selectedItem.id == 0;
    cov_1hqp0yq0kg.s[201]++;
    $scope.deletedMilestone = [];
    cov_1hqp0yq0kg.s[202]++;
    $CRUDService.getAll(PATH, { get: 'all', id: (cov_1hqp0yq0kg.b[57][0]++, item.id) || (cov_1hqp0yq0kg.b[57][1]++, 0) }, function (data) {
      cov_1hqp0yq0kg.f[27]++;
      cov_1hqp0yq0kg.s[203]++;

      for (var _iterator7 = data, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
        var _ref7;

        if (_isArray7) {
          if (_i7 >= _iterator7.length) break;
          _ref7 = _iterator7[_i7++];
        } else {
          _i7 = _iterator7.next();
          if (_i7.done) break;
          _ref7 = _i7.value;
        }

        var el = _ref7;
        cov_1hqp0yq0kg.s[204]++;

        if (el.PLANNED_DATE) {
          cov_1hqp0yq0kg.b[58][0]++;
          cov_1hqp0yq0kg.s[205]++;

          el.PLANNED_DATE = Date.newDate(el.PLANNED_DATE);
        } else {
          cov_1hqp0yq0kg.b[58][1]++;
        }
        cov_1hqp0yq0kg.s[206]++;
        if (el.ACTUAL_DATE) {
          cov_1hqp0yq0kg.b[59][0]++;
          cov_1hqp0yq0kg.s[207]++;

          el.ACTUAL_DATE = Date.newDate(el.ACTUAL_DATE);
        } else {
          cov_1hqp0yq0kg.b[59][1]++;
        }

        cov_1hqp0yq0kg.s[208]++;
        el.REALIZE = el.REALIZE == 1;
      }
      cov_1hqp0yq0kg.s[209]++;
      $scope.listMilestone = data;
    });
  };
  cov_1hqp0yq0kg.s[210]++;
  $scope.deleteItem = function (item) {
    cov_1hqp0yq0kg.f[28]++;
    cov_1hqp0yq0kg.s[211]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_1hqp0yq0kg.f[29]++;
      cov_1hqp0yq0kg.s[212]++;

      if (isconfirm) {
        cov_1hqp0yq0kg.b[60][0]++;
        cov_1hqp0yq0kg.s[213]++;

        return;
      } else {
        cov_1hqp0yq0kg.b[60][1]++;
      }
      cov_1hqp0yq0kg.s[214]++;
      $scope.isloading = true;
      var validateItem = (cov_1hqp0yq0kg.s[215]++, {
        ADR_PROJET: item.ADR_PROJET,
        AG_EXE_PROJET: item.AG_EXE_PROJET,
        CODE_ESPACE: item.CODE_ESPACE,
        CODE_PRJ: item.CODE_PRJ,
        DESCRIPTION_PROJET: item.DESCRIPTION_PROJET,
        EMAIL_PROJET: item.EMAIL_PROJET,
        DATE_DEB_PROJET: $deltadate.format(item.DATE_DEB_PROJET, 'dd/mm/yyyy'),
        DATE_FIN_PROJET: $deltadate.format(item.DATE_FIN_PROJET, 'dd/mm/yyyy'),
        Format_cout: item.Format_cout,
        LIBELLE_PROJET: item.LIBELLE_PROJET,
        PAYS_PROJET: item.PAYS_PROJET.id,
        TEL_PROJET: item.TEL_PROJET,
        FAX_PROJET: item.FAX_PROJET,

        id: item.id
      });
      cov_1hqp0yq0kg.s[216]++;
      $CRUDService.delet($scope.PATH, { action: 'supp', valeur: $filter('json')(validateItem) }, function (data) {
        cov_1hqp0yq0kg.f[30]++;
        cov_1hqp0yq0kg.s[217]++;

        if (data < 0) {
          cov_1hqp0yq0kg.b[61][0]++;
          cov_1hqp0yq0kg.s[218]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('PROJECT.ERROR.DELETE')
          });
          cov_1hqp0yq0kg.s[219]++;
          $scope.isloading = false;
          cov_1hqp0yq0kg.s[220]++;
          return;
        } else {
          cov_1hqp0yq0kg.b[61][1]++;
        }
        cov_1hqp0yq0kg.s[221]++;
        $scope.filter.processFilter();
      });
    });
  };

  cov_1hqp0yq0kg.s[222]++;
  $scope.select = function (projet) {
    cov_1hqp0yq0kg.f[31]++;

    var selectedProjet = (cov_1hqp0yq0kg.s[223]++, angular.copy(projet));
    cov_1hqp0yq0kg.s[224]++;
    $rootScope.setAtHome(false);
    cov_1hqp0yq0kg.s[225]++;
    $otherHttpService.post($scope.PATH, { action: 'setActive', id: projet.id }, function (data) {
      cov_1hqp0yq0kg.f[32]++;
      cov_1hqp0yq0kg.s[226]++;

      $rootScope.setProject({
        project: selectedProjet,
        droit: data.droits,
        connected: data.connect,
        isAdmin: data.isAdmin,
        canAccessAdminPanel: data.canAccessAdminPanel,
        link: data.a,
        admin: data.res,
        profils: data.profils,
        lastLogLevel: data.lL
      });
      cov_1hqp0yq0kg.s[227]++;
      $deltaclearData.clearData();
      cov_1hqp0yq0kg.s[228]++;
      $deltaGeoData.__initialise();
      cov_1hqp0yq0kg.s[229]++;
      $location.path('/app/dashboard').replace();
    });
  };
  cov_1hqp0yq0kg.s[230]++;
  $scope.addMilestone = function () {
    cov_1hqp0yq0kg.f[33]++;
    cov_1hqp0yq0kg.s[231]++;

    $scope.editMilestone({
      id: -Date.newDate().getTime(),
      NAME: '',
      PLANNED_DATE: $deltadate.format(Date.newDate(), 'YYYY-MM-DD'),
      ACTUAL_DATE: $deltadate.format(Date.newDate(), 'YYYY-MM-DD'),
      COMMENTS: '',
      REALIZE: false
    });
  };

  cov_1hqp0yq0kg.s[232]++;
  $scope.editMilestone = function (item) {
    cov_1hqp0yq0kg.f[34]++;
    cov_1hqp0yq0kg.s[233]++;

    $scope.selectedMilestone = angular.copy(item);
    cov_1hqp0yq0kg.s[234]++;
    $scope.selectedMilestone.PLANNED_DATE = Date.newDate($scope.selectedMilestone.PLANNED_DATE);
    cov_1hqp0yq0kg.s[235]++;
    $scope.selectedMilestone.ACTUAL_DATE = Date.newDate($scope.selectedMilestone.ACTUAL_DATE);
    cov_1hqp0yq0kg.s[236]++;

    $uibModal.open({
      templateUrl: 'app/views/project/edit/milestone.html',
      controller: milestone_edit,
      scope: $scope,
      size: 'xs_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal'
    });
  };
  cov_1hqp0yq0kg.s[237]++;
  $scope.validateMilestone = function (item) {
    cov_1hqp0yq0kg.f[35]++;

    var data = (cov_1hqp0yq0kg.s[238]++, {
      id: item.id,
      NAME: item.NAME,
      PLANNED_DATE: $deltadate.format(item.PLANNED_DATE, 'YYYY-MM-DD'),
      ACTUAL_DATE: $deltadate.format(item.ACTUAL_DATE, 'YYYY-MM-DD'),
      COMMENTS: item.COMMENTS,
      REALIZE: item.REALIZE
    });

    var _d = (cov_1hqp0yq0kg.s[239]++, $filter('filter')($scope.listMilestone, { id: data.id }, true));
    var index = (cov_1hqp0yq0kg.s[240]++, $scope.listMilestone.indexOf(_d[0]));
    cov_1hqp0yq0kg.s[241]++;
    if (index >= 0) {
      cov_1hqp0yq0kg.b[62][0]++;
      cov_1hqp0yq0kg.s[242]++;

      $scope.listMilestone[index] = data;
    } else {
      cov_1hqp0yq0kg.b[62][1]++;
      cov_1hqp0yq0kg.s[243]++;

      $scope.listMilestone.push(data);
    }
  };

  cov_1hqp0yq0kg.s[244]++;
  $scope.deleteMilestone = function (item) {
    cov_1hqp0yq0kg.f[36]++;
    cov_1hqp0yq0kg.s[245]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_1hqp0yq0kg.f[37]++;
      cov_1hqp0yq0kg.s[246]++;

      if (isconfirm) {
        cov_1hqp0yq0kg.b[63][0]++;
        cov_1hqp0yq0kg.s[247]++;

        return;
      } else {
        cov_1hqp0yq0kg.b[63][1]++;
      }
      var index = (cov_1hqp0yq0kg.s[248]++, $scope.listMilestone.indexOf(item));
      cov_1hqp0yq0kg.s[249]++;
      if (index >= 0) {
        cov_1hqp0yq0kg.b[64][0]++;
        cov_1hqp0yq0kg.s[250]++;

        if (item.id > 0) {
          cov_1hqp0yq0kg.b[65][0]++;
          cov_1hqp0yq0kg.s[251]++;

          $scope.deletedMilestone.push(item.id);
        } else {
          cov_1hqp0yq0kg.b[65][1]++;
        }
        cov_1hqp0yq0kg.s[252]++;
        $scope.listMilestone.splice(index, 1);
      } else {
        cov_1hqp0yq0kg.b[64][1]++;
      }
    });
  };

  cov_1hqp0yq0kg.s[253]++;
  $CRUDService.save($scope.PATH, { action: 'delete_img_portfolio' });

  cov_1hqp0yq0kg.s[254]++;
  $scope.isloading = true;
  cov_1hqp0yq0kg.s[255]++;
  $CRUDService.getAll('DefaultLogFrame', { get: 'all' }, function (data) {
    cov_1hqp0yq0kg.f[38]++;
    cov_1hqp0yq0kg.s[256]++;

    if (data) {
      cov_1hqp0yq0kg.b[66][0]++;
      cov_1hqp0yq0kg.s[257]++;

      $scope.listOptionSEMethods = data;
      cov_1hqp0yq0kg.s[258]++;
      $scope.listOptionSEMethods.push({ id: '0', LABEL_LOG_FRAME: $translate.instant('PROJECT.CUSTOM_LOGFRAME') });
    } else {
      cov_1hqp0yq0kg.b[66][1]++;
    }
    cov_1hqp0yq0kg.s[259]++;
    $scope.getAll();
  });

  cov_1hqp0yq0kg.s[260]++;
  $scope.imageUpdated = null;

  var uploader = (cov_1hqp0yq0kg.s[261]++, $scope.uploader = new FileUploader({
    headers: $CRUDService.getHeader(),
    url: $CRUDService.getServerAdress() + 'web_server.php?action=img_portfolio&method=1&' + $CRUDService.getComplement() + '&li_bksb=Projet',
    alias: 'fileformatrapp',
    removeAfterUpload: true
  }));

  cov_1hqp0yq0kg.s[262]++;
  uploader.onAfterAddingFile = function (fileItem, a, b, c, d, e) {
    cov_1hqp0yq0kg.f[39]++;
    cov_1hqp0yq0kg.s[263]++;

    fileItem.url = uploader.url + '&id=' + $scope.selectedItem.id;
    cov_1hqp0yq0kg.s[264]++;
    $scope.isloading = true;
    cov_1hqp0yq0kg.s[265]++;
    fileItem.upload();
  };

  cov_1hqp0yq0kg.s[266]++;
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    cov_1hqp0yq0kg.f[40]++;
    cov_1hqp0yq0kg.s[267]++;

    $scope.imageUpdated = $deltahttp.getProjectRepository(response.f);
    cov_1hqp0yq0kg.s[268]++;
    $scope.isloading = false;
  };

  cov_1hqp0yq0kg.s[269]++;
  $CRUDService.getAll('CategoryPersonnaliseA', { get: 'all' }, function (data) {
    cov_1hqp0yq0kg.f[41]++;
    cov_1hqp0yq0kg.s[270]++;

    console.log("Structure données : ", data);
    cov_1hqp0yq0kg.s[271]++;
    $scope.categoryPers_A = data;
  });

  cov_1hqp0yq0kg.s[272]++;
  $CRUDService.getAll('CategoryPersonnaliseB', { get: 'all' }, function (data) {
    cov_1hqp0yq0kg.f[42]++;
    cov_1hqp0yq0kg.s[273]++;

    $scope.categoryPers_B = data;
  });

  cov_1hqp0yq0kg.s[274]++;
  $scope.updateCatPersA = function (item, deleteItem) {
    cov_1hqp0yq0kg.f[43]++;
    cov_1hqp0yq0kg.s[275]++;

    $scope.categoryPers_A = (cov_1hqp0yq0kg.b[67][0]++, $scope.categoryPers_A) || (cov_1hqp0yq0kg.b[67][1]++, []);
    cov_1hqp0yq0kg.s[276]++;
    if (deleteItem) {
      cov_1hqp0yq0kg.b[68][0]++;
      cov_1hqp0yq0kg.s[277]++;

      $scope.categoryPers_A = $scope.categoryPers_A.filter(function (categoryPers) {
        cov_1hqp0yq0kg.f[44]++;
        cov_1hqp0yq0kg.s[278]++;

        return categoryPers.id != item.id;
      });
      cov_1hqp0yq0kg.s[279]++;
      return;
    } else {
      cov_1hqp0yq0kg.b[68][1]++;
    }
    cov_1hqp0yq0kg.s[280]++;
    for (var _iterator8 = $scope.categoryPers_A, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
      var _ref8;

      if (_isArray8) {
        if (_i8 >= _iterator8.length) break;
        _ref8 = _iterator8[_i8++];
      } else {
        _i8 = _iterator8.next();
        if (_i8.done) break;
        _ref8 = _i8.value;
      }

      var categoryPers = _ref8;
      cov_1hqp0yq0kg.s[281]++;

      if (categoryPers.id == item.id) {
        cov_1hqp0yq0kg.b[69][0]++;
        cov_1hqp0yq0kg.s[282]++;

        categoryPers.NAME = item.NAME;
        cov_1hqp0yq0kg.s[283]++;
        categoryPers.COLOR = item.COLOR;
        cov_1hqp0yq0kg.s[284]++;
        return;
      } else {
        cov_1hqp0yq0kg.b[69][1]++;
      }
    }
    cov_1hqp0yq0kg.s[285]++;
    $scope.categoryPers_A.push(item);
  };

  cov_1hqp0yq0kg.s[286]++;
  $scope.updateCatPersB = function (item, deleteItem) {
    cov_1hqp0yq0kg.f[45]++;
    cov_1hqp0yq0kg.s[287]++;

    $scope.categoryPers_B = (cov_1hqp0yq0kg.b[70][0]++, $scope.categoryPers_B) || (cov_1hqp0yq0kg.b[70][1]++, []);
    cov_1hqp0yq0kg.s[288]++;
    if (deleteItem) {
      cov_1hqp0yq0kg.b[71][0]++;
      cov_1hqp0yq0kg.s[289]++;

      $scope.categoryPers_B = $scope.categoryPers_B.filter(function (categoryPers) {
        cov_1hqp0yq0kg.f[46]++;
        cov_1hqp0yq0kg.s[290]++;

        return categoryPers.id != item.id;
      });
      cov_1hqp0yq0kg.s[291]++;
      return;
    } else {
      cov_1hqp0yq0kg.b[71][1]++;
    }
    cov_1hqp0yq0kg.s[292]++;
    for (var _iterator9 = $scope.categoryPers_B, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
      var _ref9;

      if (_isArray9) {
        if (_i9 >= _iterator9.length) break;
        _ref9 = _iterator9[_i9++];
      } else {
        _i9 = _iterator9.next();
        if (_i9.done) break;
        _ref9 = _i9.value;
      }

      var categoryPers = _ref9;
      cov_1hqp0yq0kg.s[293]++;

      if (categoryPers.id == item.id) {
        cov_1hqp0yq0kg.b[72][0]++;
        cov_1hqp0yq0kg.s[294]++;

        categoryPers.NAME = item.NAME;
        cov_1hqp0yq0kg.s[295]++;
        categoryPers.COLOR = item.COLOR;
        cov_1hqp0yq0kg.s[296]++;
        return;
      } else {
        cov_1hqp0yq0kg.b[72][1]++;
      }
    }
    cov_1hqp0yq0kg.s[297]++;
    $scope.categoryPers_B.push(item);
  };

  cov_1hqp0yq0kg.s[298]++;

  $scope.openPersonalize_1 = function () {
    cov_1hqp0yq0kg.f[47]++;
    cov_1hqp0yq0kg.s[299]++;

    $uibModal.open({
      templateUrl: 'app/views/program/first_customed_category.html',
      controller: Personnalize_1_Ctrl_Project_edit,
      scope: $scope,
      size: 'sm_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal'
    });
  };

  cov_1hqp0yq0kg.s[300]++;
  $scope.openPersonalize_2 = function () {
    cov_1hqp0yq0kg.f[48]++;
    cov_1hqp0yq0kg.s[301]++;

    $uibModal.open({
      templateUrl: 'app/views/program/second_customed_category.html',
      controller: Personnalize_2_Ctrl_Project_edit,
      scope: $scope,
      size: 'sm_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal'
    });
  };
});
function Personnalize_1_Ctrl_Project_edit($scope, $uibModalInstance, $filter, $CRUDService, SweetAlert, $translate) {
  cov_1hqp0yq0kg.f[49]++;
  cov_1hqp0yq0kg.s[302]++;

  $scope.addCategory = function () {
    cov_1hqp0yq0kg.f[50]++;
    cov_1hqp0yq0kg.s[303]++;

    $scope.editCategory({
      id: 0,
      NAME: ''
    });
  };

  cov_1hqp0yq0kg.s[304]++;
  $scope.editCategory = function (item) {
    cov_1hqp0yq0kg.f[51]++;
    cov_1hqp0yq0kg.s[305]++;

    $scope.error_code = {};
    cov_1hqp0yq0kg.s[306]++;
    $scope.selectedCatPersA = angular.copy(item);
  };

  cov_1hqp0yq0kg.s[307]++;
  $scope.cancelCategory = function () {
    cov_1hqp0yq0kg.f[52]++;
    cov_1hqp0yq0kg.s[308]++;

    $scope.selectedCatPersA = null;
  };

  cov_1hqp0yq0kg.s[309]++;
  $scope.validateCategory = function () {
    cov_1hqp0yq0kg.f[53]++;
    cov_1hqp0yq0kg.s[310]++;

    $scope.error_code = {};
    cov_1hqp0yq0kg.s[311]++;
    $scope.categoryPers_A = [];
    cov_1hqp0yq0kg.s[312]++;

    if ((cov_1hqp0yq0kg.b[74][0]++, !$scope.categoryPers_A) || (cov_1hqp0yq0kg.b[74][1]++, !Array.isArray($scope.categoryPers_A))) {
      cov_1hqp0yq0kg.b[73][0]++;
      cov_1hqp0yq0kg.s[313]++;

      console.warn('categoryPers_A n\'est pas un tableau valide:', $scope.categoryPers_A);
      cov_1hqp0yq0kg.s[314]++;

      $scope.categoryPers_A = [];
    } else {
      cov_1hqp0yq0kg.b[73][1]++;
    }

    cov_1hqp0yq0kg.s[315]++;

    if ((cov_1hqp0yq0kg.b[76][0]++, !$scope.selectedCatPersA) || (cov_1hqp0yq0kg.b[76][1]++, !$scope.selectedCatPersA.NAME)) {
      cov_1hqp0yq0kg.b[75][0]++;
      cov_1hqp0yq0kg.s[316]++;

      $scope.error_code.name = true;
      cov_1hqp0yq0kg.s[317]++;
      return;
    } else {
      cov_1hqp0yq0kg.b[75][1]++;
    }

    cov_1hqp0yq0kg.s[318]++;

    if ($scope.categoryPers_A.filter(function (category) {
      cov_1hqp0yq0kg.f[54]++;
      cov_1hqp0yq0kg.s[319]++;

      return (cov_1hqp0yq0kg.b[78][0]++, $scope.selectedCatPersA.NAME.toUpperCase() === category.NAME.toUpperCase()) && (cov_1hqp0yq0kg.b[78][1]++, category.id != $scope.selectedCatPersA.id);
    }).length > 0) {
      cov_1hqp0yq0kg.b[77][0]++;
      cov_1hqp0yq0kg.s[320]++;

      $scope.error_code.name = true;
      cov_1hqp0yq0kg.s[321]++;
      return;
    } else {
      cov_1hqp0yq0kg.b[77][1]++;
    }

    cov_1hqp0yq0kg.s[322]++;
    $CRUDService.save('CategoryPersonnaliseA', {
      action: 'MiseAJour',
      valeur: $filter('json')($scope.selectedCatPersA)
    }, function (data) {
      cov_1hqp0yq0kg.f[55]++;
      cov_1hqp0yq0kg.s[323]++;

      $scope.selectedCatPersA.id = String(parseInt(data, 10));
      cov_1hqp0yq0kg.s[324]++;
      $scope.updateCatPersA(angular.copy($scope.selectedCatPersA));
      cov_1hqp0yq0kg.s[325]++;
      $scope.selectedCatPersA = null;
    });
  };

  cov_1hqp0yq0kg.s[326]++;
  $scope.deleteCategory = function (item) {
    cov_1hqp0yq0kg.f[56]++;
    cov_1hqp0yq0kg.s[327]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_1hqp0yq0kg.f[57]++;
      cov_1hqp0yq0kg.s[328]++;

      if (isconfirm) {
        cov_1hqp0yq0kg.b[79][0]++;
        cov_1hqp0yq0kg.s[329]++;

        return;
      } else {
        cov_1hqp0yq0kg.b[79][1]++;
      }
      cov_1hqp0yq0kg.s[330]++;
      $scope.isloading = true;
      var validateItem = (cov_1hqp0yq0kg.s[331]++, {
        id: item.id
      });
      cov_1hqp0yq0kg.s[332]++;
      $CRUDService.delet('CategoryPersonnaliseA', { action: 'supp', id: item.id }, function (data) {
        cov_1hqp0yq0kg.f[58]++;
        cov_1hqp0yq0kg.s[333]++;

        if (data < 0) {
          cov_1hqp0yq0kg.b[80][0]++;
          cov_1hqp0yq0kg.s[334]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('PORTFOLIO.ERROR.DELETE')
          });
          cov_1hqp0yq0kg.s[335]++;
          $scope.isloading = false;
          cov_1hqp0yq0kg.s[336]++;
          return;
        } else {
          cov_1hqp0yq0kg.b[80][1]++;
        }
        cov_1hqp0yq0kg.s[337]++;
        $scope.updateCatPersA({ id: validateItem.id }, true);
      });
    });
  };

  cov_1hqp0yq0kg.s[338]++;
  $scope.closeModal = function () {
    cov_1hqp0yq0kg.f[59]++;
    cov_1hqp0yq0kg.s[339]++;

    $uibModalInstance.dismiss('cancel');
  };
}

function Personnalize_2_Ctrl_Project_edit($scope, $uibModalInstance, $filter, $CRUDService, SweetAlert, $translate) {
  cov_1hqp0yq0kg.f[60]++;
  cov_1hqp0yq0kg.s[340]++;

  $scope.addCategory = function () {
    cov_1hqp0yq0kg.f[61]++;
    cov_1hqp0yq0kg.s[341]++;

    $scope.editCategory({
      id: 0,
      NAME: ''
    });
  };

  cov_1hqp0yq0kg.s[342]++;
  $scope.editCategory = function (item) {
    cov_1hqp0yq0kg.f[62]++;
    cov_1hqp0yq0kg.s[343]++;

    $scope.error_code = {};
    cov_1hqp0yq0kg.s[344]++;
    $scope.selectedCatPersB = angular.copy(item);
  };

  cov_1hqp0yq0kg.s[345]++;
  $scope.cancelCategory = function () {
    cov_1hqp0yq0kg.f[63]++;
    cov_1hqp0yq0kg.s[346]++;

    $scope.selectedCatPersB = null;
  };

  cov_1hqp0yq0kg.s[347]++;
  $scope.validateCategory = function () {
    cov_1hqp0yq0kg.f[64]++;
    cov_1hqp0yq0kg.s[348]++;

    $scope.error_code = {};

    cov_1hqp0yq0kg.s[349]++;

    if ((cov_1hqp0yq0kg.b[82][0]++, !$scope.categoryPers_B) || (cov_1hqp0yq0kg.b[82][1]++, !Array.isArray($scope.categoryPers_B))) {
      cov_1hqp0yq0kg.b[81][0]++;
      cov_1hqp0yq0kg.s[350]++;

      console.warn('categoryPers_B n\'est pas un tableau valide:', $scope.categoryPers_B);
      cov_1hqp0yq0kg.s[351]++;

      $scope.categoryPers_B = [];
    } else {
      cov_1hqp0yq0kg.b[81][1]++;
    }

    cov_1hqp0yq0kg.s[352]++;

    if ((cov_1hqp0yq0kg.b[84][0]++, !$scope.selectedCatPersB) || (cov_1hqp0yq0kg.b[84][1]++, !$scope.selectedCatPersB.NAME)) {
      cov_1hqp0yq0kg.b[83][0]++;
      cov_1hqp0yq0kg.s[353]++;

      $scope.error_code.name = true;
      cov_1hqp0yq0kg.s[354]++;
      return;
    } else {
      cov_1hqp0yq0kg.b[83][1]++;
    }

    cov_1hqp0yq0kg.s[355]++;

    if ($scope.categoryPers_B.filter(function (category) {
      cov_1hqp0yq0kg.f[65]++;
      cov_1hqp0yq0kg.s[356]++;

      return (cov_1hqp0yq0kg.b[86][0]++, $scope.selectedCatPersB.NAME.toUpperCase() === category.NAME.toUpperCase()) && (cov_1hqp0yq0kg.b[86][1]++, category.id != $scope.selectedCatPersB.id);
    }).length > 0) {
      cov_1hqp0yq0kg.b[85][0]++;
      cov_1hqp0yq0kg.s[357]++;

      $scope.error_code.name = true;
      cov_1hqp0yq0kg.s[358]++;
      return;
    } else {
      cov_1hqp0yq0kg.b[85][1]++;
    }

    cov_1hqp0yq0kg.s[359]++;
    $CRUDService.save('CategoryPersonnaliseB', {
      action: 'MiseAJour',
      valeur: $filter('json')($scope.selectedCatPersB)
    }, function (data) {
      cov_1hqp0yq0kg.f[66]++;
      cov_1hqp0yq0kg.s[360]++;

      $scope.selectedCatPersB.id = String(parseInt(data, 10));
      cov_1hqp0yq0kg.s[361]++;
      $scope.updateCatPersB(angular.copy($scope.selectedCatPersB));
      cov_1hqp0yq0kg.s[362]++;
      $scope.selectedCatPersB = null;
    });
  };

  cov_1hqp0yq0kg.s[363]++;
  $scope.deleteCategory = function (item) {
    cov_1hqp0yq0kg.f[67]++;
    cov_1hqp0yq0kg.s[364]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_1hqp0yq0kg.f[68]++;
      cov_1hqp0yq0kg.s[365]++;

      if (isconfirm) {
        cov_1hqp0yq0kg.b[87][0]++;
        cov_1hqp0yq0kg.s[366]++;

        return;
      } else {
        cov_1hqp0yq0kg.b[87][1]++;
      }
      cov_1hqp0yq0kg.s[367]++;
      $scope.isloading = true;
      var validateItem = (cov_1hqp0yq0kg.s[368]++, {
        id: item.id
      });
      cov_1hqp0yq0kg.s[369]++;
      $CRUDService.delet('CategoryPersonnaliseB', { action: 'supp', id: item.id }, function (data) {
        cov_1hqp0yq0kg.f[69]++;
        cov_1hqp0yq0kg.s[370]++;

        if (data < 0) {
          cov_1hqp0yq0kg.b[88][0]++;
          cov_1hqp0yq0kg.s[371]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('PORTFOLIO.ERROR.DELETE')
          });
          cov_1hqp0yq0kg.s[372]++;
          $scope.isloading = false;
          cov_1hqp0yq0kg.s[373]++;
          return;
        } else {
          cov_1hqp0yq0kg.b[88][1]++;
        }
        cov_1hqp0yq0kg.s[374]++;
        $scope.updateCatPersB({ id: validateItem.id }, true);
      });
    });
  };

  cov_1hqp0yq0kg.s[375]++;
  $scope.closeModal = function () {
    cov_1hqp0yq0kg.f[70]++;
    cov_1hqp0yq0kg.s[376]++;

    $uibModalInstance.dismiss('cancel');
  };
}